{
  "translation": {
    "ai_templates": {
      "menu_title_pet": "Portraits d'animaux",
      "menu_title_family": "Portraits de famille",
      "menu_title_kids": "Art mural enfants",
      "menu_title_places": "Art des Lieux",
      "menu_title_travel_posters": "Affiches de voyage",
      "menu_title_vintage_posters": "Affiches vintage",
      "menu_title_home_hobbies": "Maison & loisirs",
      "menu_title_kitchen_art": "Art de cuisine",
      "menu_title_food_drink_art": "Cuisine & boissons",
      "menu_title_food_recipe_art": "Cuisine & recettes",
      "menu_title_travel": "Voyage",
      "kids_wall": {
        "child_name": "Prénom de l'enfant",
        "interests_label": "Citez 2-3 choses qu'il/elle adore",
        "interests_placeholder": "ex., dinosaures, football, licornes",
        "interests_hint": "Évitez les personnages déposés"
      },
      "upload_menu": {
        "text_input_title": "Nom de l'animal (facultatif)",
        "create": "Créer",
        "processing": "Traitement...",
        "upload_photo": "Télécharger Photo",
        "cta": {
          "upload_pet_photo": "Télécharger Photo d'Animal",
          "upload_couple_photo": "Télécharger Photo de Couple",
          "upload_old_photo": "Télécharger Ancienne Photo",
          "upload_photo_with_faces": "Télécharger Photo avec Visages",
          "upload_scenic_photo": "Télécharger Photo de Paysage",
          "upload_family_photo": "Télécharger Photo de Famille"
        }
      },
      "faces_selection": {
        "generate_button": "Générer les Photos ({{count}} {{label}})",
        "no_faces_detected": "Aucun visage détecté",
        "people": "Personnes",
        "pet": "Animal",
        "pets": "Animaux",
        "portraits": "Portraits",
        "person": "Personne",
        "subtitle": "Assurez-vous que les visages sont nets et montrent les yeux et les cheveux",
        "title": "Sélectionner les Visages"
      },
      "multi_upload": {
        "cta": "Télécharger 1-9 Photos",
        "title": "Pour les meilleurs résultats"
      },
      "results": {
        "add_tile": "Ajouter un Tile",
        "next": "Suivant"
      },
      "loading": {
        "creating_photos": "Création des Photos..."
      },
      "variations": {
        "generation_failed": "Impossible de créer ton nouveau style. Réessaie.",
        "create_button_one": "Créer {{count}} portrait",
        "create_button_other": "Créer {{count}} portraits",
        "add_portraits_line_1": "Ajoute des portraits",
        "add_portraits_line_2": "pour",
        "add_portraits_for_pet": "Ajoute des portraits pour ton animal",
        "change_pet_photo": "Changer la photo de l'animal",
        "back_to_add_options": "Retour aux options",
        "load_failed": "Impossible de charger les styles. Réessaie.",
        "no_more_templates": "Plus de modèles pour ton animal",
        "generating_snackbar": "Création"
      },
      "errors": {
        "unexpected_error": "Échec de la génération d'image",
        "safety_reject": "Image rejetée pour des raisons de sécurité",
        "service_unavailable": "Échec : Service indisponible",
        "image_too_large": "Échec : Image trop grande",
        "image_processing_failed": "Échec : Impossible de traiter l'image",
        "rate_limit": "Vous avez atteint la limite de demandes pour aujourd'hui. Réessayez demain."
      },
      "variants": {
        "boy": "Garçon",
        "girl": "Fille"
      }
    },
    "art": {
      "collection": {
        "categories": {
          "Abstract": "Abstrait",
          "Animals": "Animaux",
          "Beach": "Plage",
          "Best Sellers": "Meilleures ventes",
          "Botanical": "Art botanique",
          "Classic Art": "Art classique",
          "Destinations": "Destinations",
          "Faith": "Foi",
          "Famous Artists": "Artistes célèbres",
          "Flowers": "Fleurs",
          "Geometric": "Formes géométriques",
          "Kids": "Enfants",
          "Kitchen": "Cuisine",
          "Lines": "Dessin au trait",
          "Mountains": "Montagnes",
          "Nature": "Nature",
          "Plants": "Plantes",
          "Sayings": "Proverbes",
          "Travel": "Voyage",
          "Urban": "Urbaine",
          "Dogs & Cats": "Chiens & Chats"
        }
      },
      "home": {
        "cta_browse": "Parcourir la collection d'art",
        "subtitle": "Encadrez et accrochez facilement des œuvres d'art que vous aimez",
        "title": [
          "De magnifiques œuvres d'art,",
          "sur Mixtiles"
        ],
        "title_with_category": "La collection {{v1}}"
      },
      "select_art": "Choisir cette œuvre d'art"
    },
    "business": {
      "add_emails": "Ajouter les adresses e-mails",
      "company_name": "Nom de l'entreprise",
      "contact_form_title": "Remplissez ce formulaire et l'un de nos experts vous contactera dans les plus brefs délais.",
      "csv": "Télécharger un fichier CSV",
      "desired_amount_of_tiles": "Nombre de cadres souhaité",
      "employees_gift_cards": "Cartes-cadeaux pour les employés",
      "employees_to_be_gifted": "Employés bénéficiaires",
      "gift_card_for_title": "Cartes-cadeaux numériques, remise en gros",
      "submit": {
        "subtitle": "Un de nos experts vous contactera dans les plus brefs délais",
        "title": "Merci ! Votre demande a bien été reçue"
      },
      "subtitle": "Découvrez la facilité et la beauté des cadres photo personnalisés. Nos forfaits spéciaux B2B offrent des remises spéciales et l'assistance d'experts.",
      "title": "Des cadeaux d'entreprise hors du commun",
      "your_name": "Votre nom"
    },
    "centerpiece": {
      "add_wall_sign": "Ajouter une enseigne murale",
      "bottom_text": "TEXTE EN BAS",
      "customize": "Personnaliser",
      "top_text": "TEXTE EN HAUT"
    },
    "download_app": {
      "card": {
        "title": "Votre Mur de Galerie Est Prêt !",
        "subtitle": "Notre app crée de superbes murs de galerie à partir de vos meilleures photos"
      },
      "hero": {
        "title": "Vos Albums Photo Sont Prêts !",
        "subtitle": "Notre app crée de superbes albums photo à partir de vos meilleures photos"
      },
      "cta": "Télécharger l'App"
    },
    "collage": {
      "add_more": "Ajouter plus de photos pour créer un collage",
      "collage": "Collage",
      "edit_collage": "Modifier le collage",
      "exceeding_photos": {
        "choose_photos_plural": "Choisissez {{v1}} photos pour ce collage",
        "choose_photos_singular": "Choisissez 1 photo pour ce collage",
        "select_more_photos_plural": "Sélectionnez {{v1}} Photos de Plus",
        "select_more_photos_singular": "Sélectionnez 1 Photo de Plus"
      },
      "layout_rearrange_notice": "La disposition des photos sera modifiée",
      "text_limit_reached": "Vous avez atteint la limite de texte",
      "text_unsupported_size": "Changez la taille pour ajouter du texte"
    },
    "designer": {
      "add_tile_or_collage_to_enable_bulk_editing": "Ajouter un cadre ou un collage pour permettre la modification en bloc de votre commande",
      "add_tile_to_enable_bulk_editing": "Ajouter des cadres pour permettre la modification en bloc de votre commande",
      "adjust_crop_description": "Pincez pour zoomer ou balayez pour recadrer",
      "adjust_crop_description_desktop": "Faites défiler pour zoomer, glisser pour déplacer",
      "adjust_crop_hint": "Pincer ou faire glisser pour recadrer",
      "adjust_crop_hint_desktop": "Faire glisser pour ajuster le cadrage",
      "bold": "En gras",
      "border": "bordure",
      "bulk_override_warning": {
        "apply_filter": "Appliquer ce filtre",
        "apply_frame_color": "Appliquer ce cadre",
        "apply_mat": "Appliquer cette bordure",
        "apply_material": "Appliquer ce style",
        "apply_size": "Appliquer cette taille",
        "apply_to_all": "Appliquer à tous",
        "title": "Appliquer ces modifications à tous les cadres ?"
      },
      "change_mat": "Choisissez un autre effet passe-partout pour pouvoir voir les couleurs",
      "change_mat_notifications": {
        "disabled": "Disponible dans d'autres types de cadres",
        "partial_apply": {
          "generic_material_subtitle": "Certains cadres n'acceptent pas les bordures",
          "single_material_subtitle": "{{v1}} n'acceptent pas les bordures",
          "title": "Bordures partiellement appliquées"
        }
      },
      "choose_swap": "Choisissez une photo à échanger",
      "classic": "Classique",
      "color": "Couleur",
      "crop": "Cadrer",
      "delete": "Suppr.",
      "duplicate": "Dupliquer",
      "drop_files": "Déposez ici des photos à télécharger",
      "effect": "Filtre",
      "excellent_quality": {
        "cta": "J'ai compris",
        "subtitle": "Nous vous informerons en cas de problème",
        "title": "Excellente qualité photo !"
      },
      "frameless_8x8_caption": "{{v1}} seul",
      "filter": "Filtre",
      "frame": "Cadre",
      "handwriting": "Manuscrite",
      "layout": "Disposition",
      "mat": "Bordure",
      "material": "Style",
      "mixed_sizes": "Combinaison de plusieurs tailles",
      "out_of_stock_warning": {
        "approve": "Passer à {{size}}",
        "cancel": "Continuez avec les cadres {{material}}",
        "title": "Les cadres {{material}} de {{size}} sont en rupture de stock",
        "out_of_stock": "En rupture de stock",
        "product_approve": "Passer à {{product}}",
        "product_cancel": "Rester avec {{product}}",
        "product_title": "{{product}} sont en rupture de stock"
      },
      "photos": "Photos",
      "progress_bar": {
        "adding_photos": "Vos photos sont ajoutées…",
        "framing_your_photos": "Nous encadrons vos photos..."
      },
      "select_border": "Choisir une bordure",
      "select_effect": "Choisir un filtre",
      "select_filter": "Choisir un filtre",
      "select_frame": "Choisir un cadre",
      "select_frame_color": "Choisir la couleur du cadre",
      "select_layout": "Choisissez une disposition",
      "select_mat": "Choisir un effet passe-partout",
      "select_material": "Choisissez un type de style",
      "select_matting": "Choisir une bordure",
      "select_size": "Choisir une taille",
      "select_style": "Choisir un style de cadre",
      "select_text_style": "Choisissez un style de texte",
      "size": "Taille",
      "swap_positions": "Échanger les photos de place",
      "tile_deleted": "Cadre supprimé",
      "wide": "Large",
      "bad_crop": {
        "approve_btn": "Approuver et Passer Commande",
        "back_btn": "Retour",
        "desktop_subtitle": "Faites défiler pour zoomer, glissez pour déplacer",
        "edit": "Modifier la Commande Entière",
        "mobile_subtitle": "Pincez pour zoomer, glissez pour déplacer",
        "next_btn": "Suivant",
        "review_btn": "Vérifier les Photos",
        "title": "Vérifions que vos photos sont recadrées comme vous le souhaitez !"
      },
      "matting": "passe-partout",
      "recommended_size": "Recommandé {{v1}} ou plus petit",
      "select_color": "Choisir la Couleur",
      "text": "texte"
    },
    "general": {
      "address_form": {
        "add_title": "Ajouter une adresse",
        "change_save": "Mettre à jour",
        "change_title": "Modifier l'adresse",
        "form_fields": {
          "address": "Adresse",
          "address_2": "Adresse 2",
          "city": "Ville",
          "country": "Pays",
          "full_name": "Nom complet",
          "full_name_kana": "Nom en Katakana",
          "full_name_kana_placeholder": "Saisissez la lecture katakana du nom",
          "phone": "Numéro de téléphone",
          "postal": "Code postal",
          "province": "Province",
          "state": "État",
          "state_or_province": "État / Province",
          "state_or_territory": "État / Territoire",
          "zip": "Code postal"
        },
        "phone_number_info": "Ce numéro de téléphone ne sera utilisé que dans le cas où nous aurions besoin de vous contacter pour la livraison",
        "suggest_offers": "M'inscrire pour recevoir des offres exclusives par SMS et applications de messagerie",
        "suggest_offers_email": "Je m'inscris pour recevoir toutes les dernières offres exclusives par e-mail",
        "re_enter_address": "Resaisir l'adresse",
        "use_this_address_anyway": "Utiliser cette adresse quand même",
        "validation_errors": {
          "address": {
            "invalid": "Ville/État/Code postal non valide",
            "not_found": "Adresse non valide",
            "not_supported": "Oups ! Nous sommes désolés, mais {{product}} n'est pas encore disponible dans votre pays."
          },
          "city_state": {
            "invalid": "Ville ou État non valide"
          },
          "country": {
            "unsupported": "Désolé, nous ne livrons pas encore vers ce pays"
          },
          "email": {
            "invalid": "Merci d'utiliser une adresse e-mail valide"
          },
          "full_name": {
            "invalid": "Le nom complet est nécessaire (Prénom et Nom)"
          },
          "full_name_kana": {
            "missing": "Veuillez saisir la lecture en kana de votre nom",
            "invalid": "La lecture doit être en hiragana ou katakana uniquement"
          },
          "non_latin_characters": "Veuillez utiliser uniquement des caractères latins",
          "house_number": {
            "invalid": "Numéro de la rue non valide",
            "missing": "Numéro de la rue manquant"
          },
          "missing_fields": {
            "general": "Veuillez remplir tous les champs obligatoires pour continuer",
            "specific": "Veuillez indiquer votre {{v1}} pour continuer"
          },
          "name": {
            "invalid": "Merci d'ajouter votre nom complet",
            "too_long": "Le nom ne peut pas dépasser {{v1}} caractères"
          },
          "phone": {
            "invalid": "Veuillez saisir un numéro de téléphone valide"
          },
          "secondary_information": {
            "invalid": "Numéro d'apt/suite non valide",
            "missing": "Numéro d'apt/suite manquant"
          },
          "state": {
            "invalid": "État non valide"
          },
          "street": {
            "invalid": "Nom de la rue non valide",
            "missing": "Nom de la rue manquant",
            "po_box": "Livraison non possible vers des boîtes postales"
          },
          "mind_another_look": "Tu veux bien vérifier ?",
          "zip": {
            "invalid": "Code postal non valide",
            "not_found": "Code postal non valide",
            "state_mismatch": "Le code postal ne correspond pas à l'État sélectionné",
            "unsupported_territory": "Nous ne livrons pas dans cette région"
          }
        }
      },
      "applied": "appliqué",
      "auto_save_message": "Mixtiles sauvegarde votre travail",
      "best_seller": "Meilleure vente",
      "add": "Ajouter",
      "cancel": "Annuler",
      "credits": {
        "balance": "Vous avez {{v1}} sur votre solde compte Mixtiles"
      },
      "discard_changes": "Annuler ces modifications",
      "done": "Terminé",
      "each": "chacun",
      "errors": {
        "dark_mode_subTitle": "Passez en mode clair via les paramètres du système pour un affichage des couleurs plus réaliste",
        "dark_mode_title": "Le thème sombre affiche les couleurs de l'image de manière incorrecte",
        "general_description": "Désolé pour ça ! Essayez à nouveau et contactez-nous si le problème persiste.",
        "general_description_short": "Veuillez réessayer",
        "general_title": "Oups ! Quelque chose n'a pas marché",
        "general_title_short": "Quelque chose n'a pas marché",
        "order_cancelled_title": "Commande Annulée",
        "order_cancelled_refund_subtitle": "Le remboursement est en cours de traitement",
        "webgl_not_supported_subtitle": "Ouvre cette page dans Safari ou Chrome pour voir cet aperçu.",
        "webgl_not_supported_title": "Cet aperçu ne peut pas s'afficher sur ce navigateur"
      },
      "from_price": "À partir de {{v1}}",
      "gdpr_dialog": {
        "privacy_policy": "Politique de Confidentialité",
        "terms_of_use": "Conditions générales de vente"
      },
      "got_it": "Ok, j'ai compris",
      "languages": {
        "change_language": "Changer de langue",
        "de": "Deutsch",
        "en": "English",
        "es": "Español",
        "fr": "Français",
        "ja": "日本語",
        "language": "Langue"
      },
      "menu": {
        "accessibility_button": "Accessibilité",
        "add_promo_code": {
          "modal": {
            "form_title": "Votre code",
            "placeholder": "Saisir le code ici",
            "title": "Ajouter un code promo",
            "title_with_gift_card": "Ajouter un code promo ou une carte-cadeau"
          },
          "success": {
            "code_applied": "{{v1}} appliqué"
          }
        },
        "art_collection": "Collection d'art",
        "buy_gift_card": "Acheter une carte-cadeau",
        "chat_with_us": "Chattez avec nous",
        "cookie_policy": "Politique en matière de cookies",
        "faq": "Questions fréquentes",
        "for_business": "Cadeaux d'entreprise",
        "frame_your_photos": "Encadrez vos photos",
        "gift_card": "Acheter une carte cadeau",
        "gift_card_v2": "Carte cadeau",
        "help_center": "Rubriques d'aide",
        "my_orders": "Mes commandes",
        "privacy_policy": "Politique de Confidentialité",
        "promo_code_manager": {
          "promo_codes": "Codes Promo"
        },
        "use_code_to_save": "Le code '{{v1}}' a été ajouté, économisez jusqu'à {{v2}}%. Le montant de la réduction varie selon les tailles et les types de cadres choisis."
      },
      "new": "Nouveau",
      "ok": "Ok",
      "optional": "Optionnel",
      "payment_form": {
        "header": "Adresse de facturation",
        "same_shipping_address": "Les adresses de facturation et de livraison sont les mêmes",
        "validation_errors": {
          "address": {
            "missing": "Veuillez indiquer votre adresse complète pour continuer"
          },
          "missing_fields": {
            "general": "Veuillez compléter toutes les informations de paiement pour continuer"
          }
        }
      },
      "promo_code_selector": {
        "default": "par défaut",
        "disclaimer": "Le montant de la réduction varie selon les tailles et les types de cadres choisis.",
        "free_tile_description": "{{v1}} cadres de {{v2}} gratuits",
        "free_book_description": "{{v1}} livres photo de {{v2}} gratuits",
        "free_tiles": "Cadres gratuits",
        "free_books": "Livres photo gratuits",
        "promo_not_applied_to_product": "Cette promo ne s'applique pas aux {{v1}}",
        "select_volume_discount": "Choisissez une remise quantitative",
        "volume_discount_applied": "Remise quantitative appliquée",
        "gift_card_description": "{{v1}} de crédit ({{v2}} disponible)"
      },
      "promo_code_success_dialog": {
        "call_to_action": "Passer commande",
        "save_message_on_product": "Économisez {{v1}} sur {{v2}}",
        "save_up_to_message_shortened": "Économisez jusqu'à {{v1}}%",
        "size_and_material_disclaimer": "Économisez jusqu'à {{v1}}%. Le montant de la réduction varie selon les tailles et les types de cadres choisis.",
        "subtitle": {
          "gift_card": "Vous avez ajouté {{v1}} avec succès",
          "gift_card_tiles_many": "{{v1}} cadres gratuits",
          "gift_card_tiles_one": "un cadre gratuit",
          "gift_card_books_many": "{{v1}} livres photo gratuits",
          "gift_card_books_one": "un livre photo gratuit"
        },
        "title": {
          "bundle": "{{v1}}{{size_constraint}} cadres pour {{v2}}",
          "free_tiles_many": "Vous avez {{v1}} cadres gratuits{{size_constraint}} !",
          "gift_card": "Carte Cadeau Appliquée !"
        }
      },
      "refresh": "Rafraîchir",
      "skip": "Ignorer",
      "start_creating": "Commencer à créer",
      "continue_design": "Continuer la création",
      "talk_to_us": "Contactez-nous",
      "try_again": "Réessayer",
      "learn_more": "En Savoir Plus"
    },
    "google_photos": {
      "authorize_title": "Connexion à Google Photos",
      "authorize": "Connexion",
      "select_title": "Ouvrir Google Photos dans un nouvel onglet pour sélectionner des photos",
      "select_photos": "Ouvrir l'onglet",
      "error_title": "Erreur",
      "error_message": "Un problème est survenu. Veuillez réessayer.",
      "try_again": "Réessayer",
      "fetching_title": "Import des photos",
      "step_1": "Étape 1",
      "step_2": "Étape 2",
      "adding_photos": "Ajout…",
      "google_photos_requires_safari": "Google Photos nécessite l'ouverture dans Safari",
      "open_safari": "Ouvrir Safari",
      "stay_here": "Rester ici",
      "disconnect": "Déconnecter de Google Photos"
    },
    "get_started": {
      "form_fields": {
        "email": "E-mail"
      },
      "title": "Dis-nous en un peu plus sur toi..."
    },
    "gift_card": {
      "books": "Livres",
      "buy_now": "Acheter maintenant",
      "delivered_by_email_with_expiry": "Envoyée par e-mail, cette carte cadeau n'expire jamais.",
      "form": {
        "add_email_address": "Saisissez une adresse e-mail",
        "card_value_label": "Choisir un montant",
        "choose_book_size": "Choisir la taille du livre",
        "custom_placeholder": "Autre",
        "design_label": "Choisissez un visuel",
        "gift_message_label": "Message personnalisé (optionnel)",
        "gift_message_placeholder": "Ajouter un message personnel",
        "gift_scheduler_label": "Quand souhaitez-vous l'envoyer ?",
        "now": "Immédiatement",
        "recipient_email_placeholder": "Adresse e-mail du bénéficiaire",
        "recipient_label": "Pour ?",
        "sender_label": "De la part de ?",
        "sender_name_placeholder": "Saisissez votre nom",
        "today": "Aujourd'hui"
      },
      "number_of_books": "{{v1}} livres, {{v2}}",
      "number_of_tiles": "{{v1}} Cadres",
      "prepay_save_up_to": "Prépayez et économisez jusqu'à {{v1}}%",
      "prepay_save_exact": "Prépayez et économisez {{v1}}%",
      "sizes_note_2": "Disponible uniquement pour {{v1}} cadres avec ou sans bordure.",
      "switch_gift_card_type_cta": "Optez",
      "switch_to_tile_based_description": "pour notre autre carte cadeau - choisissez en fonction du nombre de cadres ou de livres que vous souhaitez offrir",
      "switch_to_value_based_description": "pour notre carte cadeau habituelle, qui vous permet d'offrir le montant monétaire de votre choix. Cette carte cadeau est valable sur toutes les tailles et différents matériaux.",
      "tiles": "Cadres",
      "title_digital": "Carte cadeau digitale",
      "your_email": "Votre e-mail"
    },
    "holidays": {
      "arrives_before_christmas": "Livraison avant Noël",
      "arrives_before_fathers_day": "Livraison avant la Fête des pères",
      "arrives_before_mothers_day": "Livraison avant la Fête des mères",
      "arrives_before_valentines_day": "Livraison avant la Saint-Valentin",
      "arrives_before_veterans_day": "Livraison avant le Veterans Day",
      "get_it_by_christmas": "Recevez-le avant Noël",
      "get_it_by_fathers_day": "Recevez-le avant la Fête des pères",
      "get_it_by_mothers_day": "Recevez-le avant la Fête des mères",
      "get_it_by_valentines_day": "Recevez-le avant la Saint-Valentin",
      "get_it_by_veterans_day": "Recevez-le avant le Veterans Day"
    },
    "homepage": {
      "photo_books_banner": {
        "subtitle": "Vu à la télé,\nCommandez maintenant",
        "cta": "Essayer maintenant"
      },
      "beauty": {
        "subtitle": "Chaque livre est doté d'une couverture rigide et mate et est imprimé sur des pages de qualité supérieure avec une finition soyeuse.",
        "title": "De la beauté à chaque page",
        "design_subtitle": "Une couverture rigide unique pour chaque voyage, avec impression premium et pages satinées pour une collection intemporelle",
        "design_title": "Conçus pour Être Collectionnés",
        "life_events_subtitle": "Une couverture rigide magnifiquement conçue, avec impression premium et pages satinées pour une collection que vous chérirez toujours",
        "life_events_title": "Conçus pour Être Collectionnés"
      },
      "chat": {
        "content": "Parlez en direct avec notre équipe d'assistance, tous les jours de 7h à minuit, heure de l'est des États-Unis.",
        "cta": "Chattez avec nous",
        "title": "Besoin d'aide ?"
      },
      "community": {
        "subtitle_black_frames": "Cadres de {{v1}} noirs",
        "subtitle_white_frames": "Cadres de {{v1}} blancs",
        "subtitle_wood_frames": "Cadres de {{v1}} bois de chêne",
        "subtitle_wood_mixed_frames": "Cadres en bois de tailles variées",
        "title": "Notre communauté"
      },
      "cookies_choices": "Vos paramètres de confidentialité",
      "covered": {
        "rated": "Noté {{v1}}",
        "rated_subtitle": "Plus de {{v1}} avis sur l'App Store",
        "reviews": "avis",
        "shipping": "Livraison rapide & offerte*",
        "shipping_free_subtitle": "Sans aucun montant minimum requis",
        "shipping_subtitle": "*Livraison offerte dès {{v1}}",
        "support": "Un service à la clientèle dédié",
        "support_short": "Un service dédié",
        "support_subtitle": "De vraies personnes prêtes à vous assister",
        "title": "Vos cadres photo personnalisés en toute confiance",
        "trustpilot": "Evalué excellent sur Trustpilot"
      },
      "faq": {
        "frames": {
          "content": "Les formats proposés vont de {{v1}} à {{v2}}, ainsi qu'une option unique de {{v3}}. Plusieurs matériaux et coloris disponibles, y compris sans cadre ou en toile.",
          "title": "Quelle est la taille des cadres ?"
        },
        "frames-art": {
          "content": "Les formats proposés vont de {{v1}} à {{v2}}. Plusieurs matériaux et coloris disponibles, y compris sans cadre ou en toile.",
          "title": "Quelle est la taille des cadres ?"
        },
        "move-tiles": {
          "content": "Oui, nos cadres photo autocollants sont repositionnables à l'infini, sans abîmer vos murs.",
          "title": "Déplacer vos cadres photo autocollants, c'est facile ?"
        },
        "photo-books-customize": {
          "content": "En toute simplicité, bien entendu ! Notre mise en page spécifique - une photo par page - garantit que chaque souvenir précieux sera mis en valeur comme il se doit. Personnalisez votre livre photo en choisissant vous-même la photo parfaite pour la couverture et faites en sorte que votre livre vous appartienne vraiment en personnalisant (ou en supprimant !) le texte de la couverture. D'un simple clic, vous pouvez centrer vos photos sur chaque page ou réorganiser leur ordre pour raconter votre histoire exactement comme vous l'avez imaginée.",
          "title": "Comment puis-je personnaliser mon livre photo ?"
        },
        "photo-books-delivery": {
          "content": "Vous pouvez vous attendre à ce que votre livre photo arrive environ {{delivery_time}} jours ouvrables après avoir passé votre commande, mais ne vous inquiétez pas - vous verrez toujours votre date de livraison estimée sur la page de paiement avant de finaliser votre commande ! Les commandes sont livrées par UPS, et le meilleur ? Les frais de port sont totalement gratuits !",
          "title": "Combien de temps faut-il pour recevoir son livre photo ?"
        },
        "photo-books-discount": {
          "content": "Excellente question ! Étant donné que les Livres Photos sont un tout nouvel ajout à notre gamme, la plupart de nos remises Mixtiles ne s'appliquent pas encore. Cependant, si vous avez des crédits Mixtiles ou une carte-cadeau de valeur, vous pouvez tout à fait les utiliser pour l'achat d'un livre photo !",
          "title": "J'ai reçu une réduction pour Mixtiles. Puis-je l'appliquer à l'achat de mon livre photo ?"
        },
        "photo-books-material": {
          "content": "Les livres photo sont exclusivement disponibles en couverture rigide, promettant une durabilité à chaque page tournée. La couverture est recouverte d'une fine pellicule mate, tandis que chaque page à l'intérieur est recouverte d'un papier velouté, au toucher soyeux et sans bois, qui enrichit les couleurs et réduit les reflets. Enfin, les livres photo sont également recyclables !",
          "title": "De quels matériaux sont faits les livres ?"
        },
        "photo-books-shipment": {
          "content": "Nous livrons actuellement aux États-Unis, au Canada, au Royaume-Uni, dans l'Union européenne et en Australie. Nous espérons étendre nos livraisons à d'autres pays dans un avenir proche !",
          "title": "Dans quels pays expédiez-vous vos livres photo ?"
        },
        "photo-books-size": {
          "content": "Les livres photo sont disponibles en trois formats pratiques : {{v1}} pour {{v1_price}}, {{v2}} pour {{v2_price}}, et {{v3}} pour {{v3_price}}. Quel que soit le nombre de photos que vous décidez d'inclure dans votre livre, le prix reste le même ! Chaque livre photo nécessite un minimum de 25 photos et un maximum de {{max_photos}} clichés de vos souvenirs les plus précieux.",
          "title": "Quels sont les formats des livres photo ?"
        },
        "photo-books-size-tiers": {
          "content": "Les livres photo sont disponibles en trois formats pratiques : {{v1}} à partir de {{v1_price}}, {{v2}} à partir de {{v2_price}} et {{v3}} à partir de {{v3_price}}. Chaque format propose trois paliers de prix simples selon le nombre de pages : jusqu'à 40, jusqu'à 120 et jusqu'à 200 pages. Chaque livre photo nécessite un minimum de 25 photos et peut contenir jusqu'à {{max_photos}} de vos souvenirs les plus précieux.",
          "title": "Quels sont les formats des livres photo ?"
        },
        "photo-books-wedding-size": {
          "content": "Le livre photo de mariage Mixtiles est proposé en {{v1}}, {{v2}} et {{v3}} afin que vous choisissiez le format idéal pour conserver les précieux souvenirs de votre grand jour.",
          "title": "Quelle taille choisir pour mon livre photo de mariage ?"
        },
        "photo-books-wedding-paper": {
          "content": "Chez Mixtiles, nous voulons que votre livre photo de mariage dure éternellement. Nos livres utilisent un papier velouté au toucher soyeux et une couverture rigide à finition mate, gages de durabilité et de rendu professionnel.",
          "title": "Quel type de papier pour créer un livre photo de mariage ?"
        },
        "photo-books-wedding-pages": {
          "content": "Le nombre de pages dépend du nombre de photos et du niveau de détail souhaité. Un bon départ se situe entre 20 et 40 pages, de quoi réunir vos souvenirs de mariage de façon complète mais concise.",
          "title": "Combien de pages pour un livre photo de mariage ?"
        },
        "photo-books-wedding-durability": {
          "content": "Un livre photo de mariage imprimé avec des matériaux de qualité et conservé correctement peut durer de nombreuses années, en préservant vos souvenirs pour les générations futures. Évitez la lumière directe et l'humidité pour prolonger sa durée de vie.",
          "title": "Combien de temps un livre photo de mariage va-t-il durer ?"
        },
        "photo-books-wedding-vs-traditional": {
          "content": "Créer un livre photo de mariage offre une façon moderne et fluide d'exposer vos souvenirs. Grâce à un processus de création en un clic, les photos sont organisées automatiquement en pages, prêtes à être commandées. Vous pouvez ensuite ajuster l'ordre si vous le souhaitez.",
          "title": "Pourquoi créer un livre photo de mariage plutôt qu'un album traditionnel ?"
        },
        "photo-books-memory-what-is": {
          "content": "Un livre de souvenirs photo est une belle collection reliée qui capture et préserve vos moments chéris. Il compile des instants de réunions familiales, de voyages ou d'événements marquants. Avec Mixtiles, créez un livre de souvenirs personnalisé qui raconte votre histoire et vous permet de revivre vos moments préférés à chaque page.",
          "title": "Qu'est-ce qu'un livre de souvenirs photo et à quoi sert-il ?"
        },
        "photo-books-memory-create": {
          "content": "Créer un livre de souvenirs avec Mixtiles est simple et intuitif. Téléversez au moins 24 photos et sélectionnez jusqu'à {{max_photos}} images. Utilisez nos outils faciles pour organiser, recadrer et zoomer. Une photo par page pour que chaque souvenir brille. Commandez via notre site ou notre app.",
          "title": "Comment créer un livre de souvenirs photo ?"
        },
        "photo-books-memory-occasions": {
          "content": "Les livres de souvenirs conviennent à de nombreuses occasions : mariages, anniversaires, anniversaires de mariage, remises de diplôme, fêtes. Ils peuvent aussi devenir de touchants livres mémoriels.",
          "title": "Pour quelles occasions un livre de souvenirs photo est-il adapté ?"
        },
        "photo-books-memory-custom": {
          "content": "Un livre de souvenirs personnalisé vous permet d'ordonner vos photos pour raconter votre histoire à votre façon. Les livres Mixtiles de qualité premium, imprimés sur papier velouté au toucher soyeux avec couverture rigide mate, allient élégance et durabilité.",
          "title": "Pourquoi créer un livre de souvenirs personnalisé ?"
        },
        "photo-books-memory-pages": {
          "content": "Les livres de souvenirs Mixtiles peuvent comporter jusqu'à {{max_photos}} pages, avec une photo par page. Chaque souvenir est ainsi mis en valeur.",
          "title": "Combien de pages puis-je inclure dans un livre de souvenirs ?"
        },
        "photo-books-memory-cover": {
          "content": "Nos livres de souvenirs ont une couverture rigide mate, élégante et durable. Choisissez une photo pour la première de couverture et personnalisez le texte. La quatrième de couverture reste sans photo pour un rendu épuré.",
          "title": "Quelles options de couverture pour les livres de souvenirs ?"
        },
        "photo-books-memory-cost": {
          "content": "Le prix d'un livre de souvenirs Mixtiles varie selon le format et le nombre de pages. Pour un tarif précis, consultez notre site ou notre application.",
          "title": "Combien coûte un livre de souvenirs photo ?"
        },
        "photo-books-memory-easiest": {
          "content": "La façon la plus simple de créer un livre de souvenirs est d'utiliser la plateforme Mixtiles. Notre site et notre app offrent des outils intuitifs pour téléverser, organiser et éditer vos photos en quelques clics. Notre support est disponible par chat en direct ou email.",
          "title": "Quelle est la façon la plus simple de créer un livre de souvenirs ?"
        },
        "photo-books-small-sizes": {
          "content": "Nous proposons trois formats : {{v1}} ({{v1_dimensions}}), {{v2}} ({{v2_dimensions}}) et {{v3}} ({{v3_dimensions}}). Le format {{v1}} est idéal pour un petit livre photo : compact et élégant.",
          "title": "Quels sont les formats des petits livres photo ?"
        },
        "photo-books-small-why-choose": {
          "content": "Un petit livre photo est portable et peu encombrant — parfait comme souvenir personnel ou cadeau. La qualité reste au rendez-vous : matériaux premium et couleurs vibrantes.",
          "title": "Pourquoi choisir un petit livre photo plutôt qu'un grand ?"
        },
        "photo-books-small-occasions": {
          "content": "Les petits livres photo sont polyvalents : réunions de famille, voyages, jalons de vie… Ils conviennent aussi aux séries thématiques (animaux, première année de bébé).",
          "title": "Quelles occasions ou thématiques pour un petit livre photo ?"
        },
        "photo-books-small-pages": {
          "content": "Les petits livres photo Mixtiles peuvent contenir de 24 à {{max_photos}} pages, avec une photo par page, pour une collection complète mais concise.",
          "title": "Combien de pages pour un petit livre photo ?"
        },
        "photo-books-small-customizable": {
          "content": "Absolument ! Avec Mixtiles, personnalisez votre petit livre : organisez, zoomez et recadrez vos photos. Choisissez aussi une photo de couverture et ajoutez du texte.",
          "title": "Les petits livres photo sont-ils personnalisables ?"
        },
        "photo-books-small-gifts": {
          "content": "Oui, les petits livres photo font d'excellents cadeaux. Leur format compact est parfait pour partager des souvenirs à l'occasion d'un anniversaire, d'un anniversaire de mariage ou des fêtes.",
          "title": "Les petits livres photo sont-ils de bons cadeaux ?"
        },
        "photo-books-small-materials": {
          "content": "Les petits livres photo Mixtiles utilisent des matériaux de haute qualité. Pages en papier velouté au toucher soyeux, sans bois, qui limite les reflets et intensifie les couleurs. Couverture rigide à film mat.",
          "title": "Quels matériaux et finitions pour les petits livres photo ?"
        },
        "photo-books-small-story": {
          "content": "Pour raconter une belle histoire, sélectionnez des photos cohérentes avec votre thème et ordonnez-les avec une progression logique. Ajustez chaque image et personnalisez la couverture avec un titre parlant.",
          "title": "Comment faire raconter une histoire à un petit livre photo ?"
        },
        "photo-books-boudoir-what-is": {
          "content": "Un livre photo boudoir est une collection intime et artistique pour célébrer votre beauté et votre confiance. Chez Mixtiles, nous le relions et l'imprimons sur papier premium pour revivre ces moments à chaque page.",
          "title": "Qu'est-ce qu'un livre photo boudoir et pourquoi en créer un ?"
        },
        "photo-books-boudoir-select-photos": {
          "content": "Choisissez des images qui reflètent votre personnalité et l'histoire voulue, avec une variété de poses et d'expressions. Nos outils vous permettent de zoomer, recadrer et réorganiser facilement.",
          "title": "Comment sélectionner les photos pour un livre boudoir ?"
        },
        "photo-books-boudoir-layout": {
          "content": "Visez un équilibre entre esthétique et narration. Sur Mixtiles, chaque page affiche une photo pour mettre chaque souvenir en valeur. Ajustez l'ordre pour créer votre propre flux.",
          "title": "Comment disposer les photos dans un livre boudoir ?"
        },
        "photo-books-boudoir-size-style": {
          "content": "Nous proposons trois formats : {{v1}}, {{v2}} et {{v3}}. Choisissez selon vos préférences et le nombre de photos. La couverture rigide mate apporte une touche d'élégance, idéale pour un livre boudoir.",
          "title": "Quel format et quel style pour un livre boudoir ?"
        },
        "photo-books-boudoir-personalize": {
          "content": "Personnalisez facilement votre livre boudoir : ajoutez une photo en couverture et un texte pour résumer votre histoire. Un résultat unique et personnel.",
          "title": "Comment personnaliser mon livre boudoir ?"
        },
        "photo-books-boudoir-cover-materials": {
          "content": "Mixtiles propose une couverture rigide mate, élégante et durable. Traditionnellement, certains livres boudoir utilisent le cuir ou le velours pour un rendu luxueux.",
          "title": "Quels matériaux de couverture conviennent aux livres boudoir ?"
        },
        "photo-books-boudoir-color-mix": {
          "content": "Mélanger couleur et noir-et-blanc apporte profondeur et contraste. Le N&B souligne l'émotion, la couleur apporte de la vivacité. Notre impression premium sublime les deux.",
          "title": "Faut-il mélanger des photos couleur et noir-et-blanc ?"
        },
        "photo-books-boudoir-order": {
          "content": "Commandez votre livre boudoir sur le site ou l'app Mixtiles. Notre création en un clic facilite le téléversement et l'organisation. Besoin d'aide ? Notre équipe est là par email ou chat.",
          "title": "Où commander un livre photo boudoir ?"
        },
        "photo-books-travel-why-make": {
          "content": "Un livre photo de voyage est une belle façon de préserver et revivre vos aventures. Mixtiles propose des livres personnalisés qui capturent l'essence de vos périples, pour une expérience plus intime qu'un album numérique.",
          "title": "Pourquoi faire un livre photo de voyage ?"
        },
        "photo-books-travel-features": {
          "content": "Ajoutez cartes, itinéraires, légendes et notes personnelles pour enrichir votre récit. Avec Mixtiles, organisez photos et texte comme vous le souhaitez.",
          "title": "Quelles fonctionnalités ajouter à un livre de voyage ?"
        },
        "photo-books-travel-cropping": {
          "content": "Notre plateforme facilite le recadrage et la réorganisation. Chaque livre adopte une mise en page avec une photo par page : chaque souvenir est mis en avant dans un style épuré.",
          "title": "Comment sont gérés le recadrage et la mise en page ?"
        },
        "photo-books-travel-details": {
          "content": "Ajoutez des légendes, des dates, des lieux et des extraits d'itinéraire pour raconter l'histoire derrière chaque photo.",
          "title": "Quels détails de voyage puis-je inclure ?"
        },
        "photo-books-travel-structure": {
          "content": "Structurez votre livre : une couverture marquante, une page d'intro, puis des photos par chronologie ou par thème (paysages, culture, cuisine). Des légendes courtes guident la lecture.",
          "title": "Comment structurer un livre de voyage pour raconter une histoire ?"
        },
        "photo-books-travel-quality": {
          "content": "Oui, nos livres de voyage sont durables et premium : papier velouté au toucher soyeux qui réduit les reflets et intensifie les couleurs, couverture rigide mate, matériaux écoresponsables.",
          "title": "Les livres de voyage sont-ils de qualité et durables ?"
        },
        "photo-books-travel-services": {
          "content": "Mixtiles propose une création en un clic : après téléversement, nous organisons vos photos dans un livre prêt à commander que vous pouvez personnaliser. Trois formats au choix.",
          "title": "Quels services ou modèles pour les livres de voyage ?"
        },
        "photo-books-travel-relive": {
          "content": "Un livre de voyage Mixtiles, c'est plus que des images : chaque page ravive les émotions et facilite le partage avec vos proches, dans un bel objet tangible.",
          "title": "Comment un livre de voyage m'aide-t-il à revivre mes aventures ?"
        },
        "photo-books-coffee-table-what-is": {
          "content": "Un livre photo de table basse est conçu pour mettre en valeur vos photos et inviter à la découverte. Mixtiles en fait des histoires visuelles personnalisées qui embellissent votre intérieur.",
          "title": "Qu'est-ce qu'un livre photo de table basse et pourquoi en créer un ?"
        },
        "photo-books-coffee-table-themes": {
          "content": "Famille, voyages, mariages ou revue de l'année : autant de thèmes parfaits. Avec Mixtiles, organisez et personnalisez vos photos en toute simplicité.",
          "title": "Quels thèmes fonctionnent bien pour un livre de table basse ?"
        },
        "photo-books-coffee-table-design": {
          "content": "Concevoir un livre de table basse est simple : téléversez et disposez vos photos. Une photo par page pour que chaque image soit mise en avant. Zoomez, recadrez et réorganisez librement.",
          "title": "Comment concevoir un livre de table basse attrayant (mise en page et contenu) ?"
        },
        "photo-books-coffee-table-travel-wedding": {
          "content": "Oui ! Les photos de voyage et de mariage sont idéales : fortes visuellement et chargées d'émotion. Nos pages au toucher soyeux et la couverture mate garantissent un rendu haut de gamme.",
          "title": "Faut-il inclure des photos de voyage ou de mariage dans un livre de table basse ?"
        },
        "photo-books-coffee-table-gifts": {
          "content": "Oui, ces livres font d'excellents cadeaux : personnels, attentionnés et intemporels pour toutes les occasions.",
          "title": "Les livres de table basse sont-ils de bons cadeaux ?"
        },
        "photo-books-coffee-table-year-review": {
          "content": "Un livre « année en revue » rassemble les moments marquants des 12 derniers mois. Avec Mixtiles, mettez jusqu'à {{max_photos}} souvenirs dans un bel ouvrage.",
          "title": "Qu'est-ce qu'un livre de table basse « année en revue » ?"
        },
        "photo-books-coffee-table-guest-house": {
          "content": "Parfaits pour maisons d'hôtes ou salles d'attente, ils créent une ambiance accueillante et engagent les visiteurs avec des attractions locales, des repères historiques ou de belles images.",
          "title": "Comment utiliser des livres de table basse dans une maison d'hôtes ou une salle d'attente ?"
        },
        "photo-books-coffee-table-suitable": {
          "content": "Un livre de table basse réussi est esthétique, durable et plein de sens. Mixtiles réunit ces critères avec des matériaux premium, un design épuré et une personnalisation poussée.",
          "title": "Qu'est-ce qui rend un livre photo adapté à une table basse ?"
        },
        "photo-books-engagement-what-is": {
          "content": "Un livre photo de fiançailles rassemble les moments menant au mariage. Chez Mixtiles, il est imprimé sur papier au toucher soyeux avec une couverture rigide mate : un souvenir élégant et durable.",
          "title": "Qu'est-ce qu'un livre photo de fiançailles et pourquoi en faire un ?"
        },
        "photo-books-engagement-photos-include": {
          "content": "Incluez un mélange qui reflète votre relation : instants spontanés, séance de fiançailles et moments partagés. Nos outils vous aident à recadrer, zoomer et réorganiser.",
          "title": "Quelles photos inclure dans un livre de fiançailles ?"
        },
        "photo-books-engagement-proposal": {
          "content": "Bien sûr ! Les photos de la demande en mariage sont parfaites pour ouvrir le récit de votre album de fiançailles.",
          "title": "Dois-je inclure les photos de la demande ?"
        },
        "photo-books-engagement-party": {
          "content": "Les photos de la fête de fiançailles ajoutent joie et convivialité à votre livre. Avec Mixtiles, vous pouvez inclure jusqu'à {{max_photos}} photos.",
          "title": "Et les photos de la fête de fiançailles — faut-il les ajouter ?"
        },
        "photo-books-engagement-vs-wedding": {
          "content": "Le livre de fiançailles couvre le chemin jusqu'au mariage (demande, célébrations, moments du quotidien). Le livre de mariage documente surtout le jour J.",
          "title": "Différences entre livres de fiançailles et livres de mariage ?"
        },
        "photo-books-engagement-cover-styles": {
          "content": "Nous proposons une couverture rigide mate, élégante et résistante. Choisissez une photo pour la couverture et personnalisez le dos avec du texte.",
          "title": "Quels styles et matériaux de couverture pour un livre de fiançailles ?"
        },
        "photo-books-engagement-story": {
          "content": "Racontez l'histoire du « oui » au mariage avec une sélection soignée et un ordre qui suit votre parcours. Notre plateforme facilite l'organisation.",
          "title": "Comment un livre de fiançailles raconte-t-il l'histoire du « oui » au mariage ?"
        },
        "photo-books-engagement-keepsake": {
          "content": "Oui, c'est un magnifique souvenir, et il peut même servir de livre d'or le jour du mariage. La qualité Mixtiles en fait un objet qui dure.",
          "title": "Un livre de fiançailles : bon souvenir ou livre d'or ?"
        },
        "photo-books-family-why-create": {
          "content": "Un livre photo familial préserve vos souvenirs dans un objet tangible. Avec Mixtiles, compilez facilement vos moments préférés dans un bel ouvrage personnalisé.",
          "title": "Pourquoi créer un livre photo familial ?"
        },
        "photo-books-family-formats": {
          "content": "Nos livres, en {{v1}}, {{v2}} et {{v3}}, sont parfaits pour la famille. Une photo par page met chaque souvenir en lumière.",
          "title": "Quels formats de livres conviennent aux photos de famille ?"
        },
        "photo-books-family-organize": {
          "content": "Organiser un livre familial est simple : téléversez et ordonnez vos photos pour raconter votre histoire. Recadrez et zoomez, puis ajustez grâce à notre création en un clic.",
          "title": "Comment organiser un livre photo familial ?"
        },
        "photo-books-family-memories": {
          "content": "Mélangez moments du quotidien et grandes occasions : vacances, fêtes, anniversaires, clichés spontanés qui reflètent l'essence de votre famille.",
          "title": "Quels souvenirs familiaux inclure ?"
        },
        "photo-books-family-pages": {
          "content": "Nos livres peuvent contenir de 24 à {{max_photos}} photos, chacune sur sa page. À vous de choisir entre un résumé concis ou une collection plus fournie.",
          "title": "Combien de pages pour un livre photo familial ?"
        },
        "photo-books-family-cover-size": {
          "content": "Couverture rigide mate et trois tailles — {{v1}}, {{v2}}, {{v3}} — pour s'adapter à vos besoins.",
          "title": "Quelles options de couverture et de taille pour les livres familiaux ?"
        },
        "photo-books-family-durable": {
          "content": "Papier au toucher soyeux et film mat sur la couverture : la durabilité est au rendez-vous. Tous nos livres sont écoresponsables et recyclables.",
          "title": "Comment rendre un livre photo familial durable ?"
        },
        "photo-books-family-story": {
          "content": "Ajoutez des légendes ou anecdotes pour tisser l'histoire familiale. Personnalisez la couverture avec une photo et un texte qui résument votre récit.",
          "title": "Comment intégrer l'histoire de ma famille dans le livre ?"
        },
        "photo-books-yearly-what-is": {
          "content": "Un livre photo annuel est une merveilleuse façon de résumer les souvenirs de l'année, en capturant l'essence de vos expériences et de vos moments marquants. Chez Mixtiles, nous offrons un moyen fluide de rassembler ces instants chéris dans un beau livre relié, pour réfléchir à votre année et la partager avec vos proches.",
          "title": "À quoi sert un livre photo annuel ?"
        },
        "photo-books-yearly-gather-photos": {
          "content": "Pour créer un livre « année en revue » complet, commencez par organiser vos photos par mois ou par événements clés. Cette méthode facilite la sélection des images qui représentent le mieux chaque période. Notre plateforme permet de téléverser et d'agencer vos photos en toute simplicité, afin que votre album raconte une histoire cohérente.",
          "title": "Comment rassembler des photos pour un album annuel ?"
        },
        "photo-books-yearly-what-include": {
          "content": "Incluez vos expériences et liens préférés de l'année écoulée. Réunions de famille, voyages ou réussites personnelles : nos livres donnent à chaque souvenir la place qu'il mérite. Avec les outils d'édition Mixtiles, zoomez, recadrez et réorganisez vos photos pour qu'elles servent parfaitement votre récit.",
          "title": "Que mettre dans un livre photo annuel ?"
        },
        "photo-books-yearly-themes-layouts": {
          "content": "Une chronologie est un thème très efficace pour un livre annuel. Elle met en valeur la progression de votre année en soulignant les moments clés dans l'ordre. Nos livres adoptent une mise en page à une photo par page, pour une lecture claire et centrée sur chaque souvenir.",
          "title": "Quels thèmes ou mises en page pour un livre annuel ?"
        },
        "photo-books-yearly-formats": {
          "content": "Nous proposons trois formats pratiques : {{v1}}, {{v2}} et {{v3}}. Chaque taille répond à des préférences différentes, du discret au plus audacieux. Chez Mixtiles, votre livre annuel est fabriqué avec des matériaux premium, dont une couverture rigide mate et des pages au toucher soyeux.",
          "title": "Quels formats existent pour les livres photo annuels ?"
        },
        "photo-books-yearly-personalize-cover": {
          "content": "Personnaliser la couverture est simple avec Mixtiles. Choisissez une photo spéciale pour la première de couverture et ajoutez un titre en foil personnalisé pour résumer votre histoire. Cette touche personnelle rend votre livre « année en revue » unique et fidèle à vos expériences.",
          "title": "Comment personnaliser la couverture d'un livre annuel ?"
        },
        "photo-books-yearly-why-make": {
          "content": "Créer un livre « année en revue » transforme vos temps forts en une véritable capsule de souvenirs. C'est une façon tangible de préserver l'essentiel et de le revivre à tout moment. Nos livres sont conçus pour durer, pour un souvenir pérenne année après année.",
          "title": "Pourquoi faire un livre « année en revue » ?"
        },
        "photo-books-yearly-how-often": {
          "content": "Nous recommandons d'en créer un chaque année afin de capter vos temps forts annuels. Cette tradition construit une collection de souvenirs à chérir. Avec Mixtiles, le processus est simple et agréable, et chaque livre est aussi spécial que les moments qu'il contient.",
          "title": "À quelle fréquence créer un livre photo annuel ?"
        },
        "photo-books-valentines-great-gift": {
          "content": "Un livre photo est un cadeau parfait pour la Saint-Valentin : il rend votre histoire d'amour tangible. Chez Mixtiles, nous proposons de beaux livres reliés qui vous permettent de feuilleter des souvenirs précieux — un présent plein de cœur. Imprimés sur un papier velouté au toucher soyeux, nos livres font vibrer les couleurs pour un souvenir impérissable.",
          "title": "Pourquoi un livre photo est-il un excellent cadeau de Saint-Valentin ?"
        },
        "photo-books-valentines-unique-ideas": {
          "content": "Une idée originale : un livre « Les raisons pour lesquelles je t'aime ». Rassemblez des photos de moments clés et associez-les à des légendes ou mots doux expliquant pourquoi vous chérissez votre partenaire. Cette personnalisation transforme une simple collection en récit significatif.",
          "title": "Quelles idées originales pour un livre de Saint-Valentin ?"
        },
        "photo-books-valentines-style": {
          "content": "Pour un style intemporel, créez votre livre de Saint-Valentin en noir et blanc. Cette approche apporte élégance et met l'émotion au premier plan. Avec Mixtiles, vous pouvez facilement éditer vos images pour obtenir cet effet, pour un livre à la fois chic et personnel.",
          "title": "Comment styliser mon livre de Saint-Valentin ?"
        },
        "photo-books-valentines-wedding-photos": {
          "content": "Absolument ! Inclure des photos de votre mariage est une belle façon de revivre l'un des moments les plus romantiques de votre vie. Nos livres présentent une photo par page, donnant à chaque souvenir toute la lumière qu'il mérite — idéal pour mêler temps forts du mariage et autres souvenirs chéris.",
          "title": "Puis-je inclure des photos de mariage dans un livre de Saint-Valentin ?"
        },
        "photo-books-valentines-focus": {
          "content": "Misez sur les moments romantiques qui définissent votre relation : première rencontre, voyage marquant ou instants du quotidien. Ces images racontent votre histoire d'amour. Nos outils d'édition vous aident à organiser et personnaliser vos photos pour un livre fidèle à votre parcours à deux.",
          "title": "Sur quoi dois-je me concentrer dans un livre de Saint-Valentin ?"
        },
        "photo-books-valentines-fun-personal": {
          "content": "Mélangez prises sur le vif et photos posées pour un livre à la fois fun et personnel. Les clichés spontanés saisissent la joie authentique, tandis que les posés mettent en valeur les grandes occasions. Avec la création en un clic de Mixtiles, organisez vos images et ajoutez vos touches perso en un rien de temps.",
          "title": "Comment rendre le livre amusant et personnel ?"
        },
        "photo-books-valentines-suitable-couples": {
          "content": "Oui, un livre de Saint-Valentin convient à tous les couples, des jeunes mariés à ceux de longue date. Ce cadeau célèbre votre chemin commun, en mêlant nouveaux et anciens souvenirs. Nos livres au design épuré et durable plaisent à toutes les étapes de la relation.",
          "title": "Un livre de Saint-Valentin convient-il à tous les couples ?"
        },
        "photo-books-valentines-gather-content": {
          "content": "Rassemblez des billets d'amour, vos photos favorites et des citations qui résument votre relation. Créez un album sur votre appareil pour tout conserver et être prêt lors de la création du livre. Nous recommandons de téléverser au moins 24 photos pour un livre de Saint-Valentin riche et touchant.",
          "title": "Comment rassembler le contenu pour un album de Saint-Valentin ?"
        },
        "shipping-location": {
          "content": "Oui, dans la plupart des pays du monde !",
          "title": "Livrez-vous à l'international ?"
        },
        "shipping-time": {
          "content": "La livraison de vos cadres photo personnalisés prend généralement une semaine. Livraison express possible dans certains pays. Un numéro de suivi accompagne chaque commande.",
          "title": "Combien de temps prend la livraison ?"
        },
        "title": "Questions fréquentes",
        "walls": {
          "content": "Non, nos cadres photo autocollants sont sans trace et repositionnables.",
          "title": "Les cadres abîment-ils les murs ?"
        },
        "photo-books-graduation-why-create": {
          "content": "Créer un livre photo de remise de diplôme est une belle façon de préserver les souvenirs d'une étape importante de la vie. Chez Mixtiles, nous proposons de superbes livres reliés qui vous permettent de sélectionner et de revivre ces moments précieux. Nos livres photo sont des souvenirs personnalisés qui capturent la joie et les réussites du jour J, offrant un rappel concret de vos accomplissements.",
          "title": "Pourquoi créer un livre photo de remise de diplôme ?"
        },
        "photo-books-graduation-what-photos": {
          "content": "Un livre photo de remise de diplôme équilibré devrait inclure une variété de photos : l'excitation du premier jour, la fierté de la cérémonie, des instants spontanés avec les amis et des événements marquants tout au long de l'année scolaire. Ensemble, ces images racontent votre parcours, en soulignant votre évolution personnelle et vos réussites.",
          "title": "Quelles photos inclure dans un album de remise de diplôme ?"
        },
        "photo-books-graduation-organize": {
          "content": "Vous pouvez organiser vos photos de remise de diplôme par ordre chronologique ou par thème. Chez Mixtiles, nous vous facilitons la tâche pour arranger vos photos exactement comme vous le souhaitez. Que vous montriez le voyage du début à la fin ou que vous groupiez par événements ou amitiés, nos outils d'édition simples vous permettent de personnaliser votre livre pour refléter votre histoire unique.",
          "title": "Comment organiser les photos ?"
        },
        "photo-books-graduation-how-many-photos": {
          "content": "Pour un livre photo de remise de diplôme Mixtiles, vous avez besoin d'au moins 24 photos et pouvez en inclure jusqu'à {{max_photos}}. Rassemblez-les depuis vos appareils, les réseaux sociaux ou auprès d'amis qui ont capturé des moments spéciaux. Cette collection offrira un portrait complet et vivant de votre expérience de fin d'études.",
          "title": "De combien de photos ai-je besoin et où les trouver ?"
        },
        "photo-books-graduation-design-theme": {
          "content": "Le choix d'un thème de design dépend de votre style et de l'histoire que vous souhaitez raconter. Nos livres photo ont une couverture rigide élégante au fini mat et sont imprimés sur un papier velouté, toucher soie, pour sublimer le rendu et le ressenti. Classique et élégant ou moderne et coloré : nous donnons vie à vos photos avec des couleurs riches et une qualité premium.",
          "title": "Quel thème choisir pour mon livre de remise de diplôme ?"
        },
        "photo-books-graduation-quotes-messages": {
          "content": "Oui, vous pouvez personnaliser votre livre en ajoutant des citations ou des messages qui résonnent avec votre parcours. Nous ne proposons pas de fonctionnalité dédiée à la création de QR codes, mais vous pouvez en générer un ailleurs et l'importer comme image. Vous pourrez ainsi ajouter des éléments interactifs qui enrichissent la valeur personnelle de votre livre.",
          "title": "Puis-je inclure des citations, des messages ou des QR codes ?"
        },
        "photo-books-graduation-sort-upload": {
          "content": "Trier et téléverser vos photos de remise de diplôme avec Mixtiles, c'est ultra simple. Notre création en un tap les organise en pages pour un livre prêt à commander. Vous pouvez ensuite personnaliser et réarranger pour que chaque page reflète votre touche personnelle.",
          "title": "Comment trier et téléverser mes photos de remise de diplôme ?"
        },
        "photo-books-graduation-templates-layouts": {
          "content": "Nos livres photo proposent une mise en page unique avec une photo par page, pour que chaque souvenir ait sa place. Ce choix simple et efficace met chaque image en valeur — idéal pour capturer l'essence de votre parcours. Avec nos outils d'édition faciles, vous pouvez recadrer et réorganiser les photos selon votre récit.",
          "title": "Quels modèles ou mises en page conviennent pour un livre de remise de diplôme ?"
        },
        "photo-books-birthday-important-moments": {
          "content": "Pour saisir l'esprit d'un anniversaire, concentrez-vous sur les moments clés : la coupe du gâteau, l'ouverture des cadeaux et les interactions avec les invités. Ces instants reflètent la joie et l'excitation de la journée, essentiels à un livre photo complet. Avec Mixtiles, vous pourrez revivre ces souvenirs à chaque page.",
          "title": "Quels moments sont importants à capturer dans un livre d'anniversaire ?"
        },
        "photo-books-birthday-photograph-party": {
          "content": "Pour un superbe livre d'anniversaire, alternez plans larges et gros plans. Capturez la pièce pour poser le décor, puis zoomez sur les détails comme les décorations et les expressions. Nos livres, imprimés sur un papier velouté, toucher soie, font briller chaque photo avec des couleurs éclatantes.",
          "title": "Comment photographier une fête d'anniversaire pour un beau livre photo ?"
        },
        "photo-books-birthday-candid-vs-posed": {
          "content": "Les photos posées ont leur place, mais les instantanés capturent souvent la joie et la spontanéité d'un anniversaire. Visez les rires, les surprises et les interactions pour un rendu authentique. Avec les fonctions d'édition Mixtiles, organisez ces moments pour créer un récit fidèle à l'ambiance de la fête.",
          "title": "Dois-je privilégier les clichés spontanés ou posés ?"
        },
        "photo-books-birthday-details-include": {
          "content": "Incluez des détails comme les décorations, le gâteau et les sourires des invités pour donner de la profondeur à votre livre. Ces éléments brossent un tableau complet de l'événement. Nos livres personnalisables mettent chaque détail en avant avec la mise en page une photo par page.",
          "title": "Quels détails dois-je inclure ?"
        },
        "photo-books-birthday-tell-story": {
          "content": "Pour raconter une histoire, classez les photos chronologiquement, de l'arrivée des invités aux derniers au revoir. Cette séquence narre naturellement la journée. Chez Mixtiles, notre création en un tap organise vos photos en un récit cohérent, avec des options de personnalisation.",
          "title": "Comment m'assurer que les photos d'anniversaire racontent une histoire ?"
        },
        "photo-books-birthday-angle-focus": {
          "content": "Avoir un thème ou un fil conducteur — palette de couleurs, motif de la fête — donne une touche unique à votre livre d'anniversaire. Il guide la sélection et l'agencement des photos pour un rendu harmonieux. Notre couverture rigide au fini mat s'accorde avec tous les thèmes et ajoute une note d'élégance.",
          "title": "Est-il utile d'avoir un angle ou un thème pour l'événement ?"
        },
        "photo-books-birthday-subjects-interest": {
          "content": "Les jeux, les tenues spéciales et les interactions marquantes créent de l'intérêt à chaque page. Ces éléments apportent variété et surprise, pour un feuilletage toujours plaisant. Avec la qualité premium de nos livres, chaque photo est mise en lumière et vos souvenirs sont magnifiés.",
          "title": "Quels sujets apportent de l'intérêt à chaque page ?"
        },
        "photo-books-birthday-how-many-photos": {
          "content": "Pour un livre d'anniversaire équilibré, visez 50 à 100 photos. Cette plage couvre l'événement sans submerger le lecteur. Les livres Mixtiles acceptent jusqu'à 150 photos, pour inclure tous vos favoris tout en gardant une mise en page claire.",
          "title": "Combien de photos inclure de la fête ?"
        },
        "photo-books-retirement-how-create": {
          "content": "Créer un livre photo de départ à la retraite avec Mixtiles est simple et agréable. Commencez par téléverser au minimum 24 photos via notre site ou notre app, et présentez jusqu'à {{max_photos}} souvenirs. Notre plateforme intuitive organise automatiquement vos images, mais vous pouvez personnaliser la mise en page pour raconter une histoire unique. Une photo par page pour faire briller chaque moment. Avec notre papier premium, velouté, toucher soie, et la couverture rigide mate élégante, votre livre sera un souvenir magnifique pour votre collègue ou proche.",
          "title": "Comment créer un livre photo de départ à la retraite pour un collègue ou un proche ?"
        },
        "photo-books-retirement-when-start-planning": {
          "content": "Nous conseillons de commencer au moins un mois à l'avance. Vous aurez le temps de réunir des photos et des messages significatifs des collègues pour un livre riche et touchant. En planifiant tôt, vous profitez de nos fonctions d'édition pour arranger et personnaliser parfaitement. Vous pouvez enregistrer temporairement vos sélections et finaliser votre chef‑d'œuvre quand vous serez prêt.",
          "title": "Quand commencer à préparer un livre de départ à la retraite ?"
        },
        "photo-books-retirement-types-photos": {
          "content": "Un livre de retraite doit refléter la carrière et la personnalité du retraité. Incluez un mélange de temps forts — projets, récompenses, promotions — et de moments du quotidien au bureau qui montrent les interactions et amitiés. Nos livres permettent de recadrer et d'ordonner les images pour qu'elles s'intègrent à votre narration.",
          "title": "Quelles photos inclure ?"
        },
        "photo-books-retirement-coworkers-contribute": {
          "content": "Absolument ! Inviter les collègues à partager des photos et des messages apporte de la profondeur et de la chaleur au livre. C'est une belle façon de réunir des points de vue variés. Notre plateforme facilite l'import et l'organisation des contributions depuis plusieurs sources.",
          "title": "Dois-je demander aux collègues de contribuer photos et messages ?"
        },
        "photo-books-retirement-humor-personal-touches": {
          "content": "L'humour et les touches personnelles rendent votre livre vraiment spécial. Pensez à ajouter des conseils amusants, des blagues de bureau ou des citations marquantes. Vous pouvez aussi intégrer des photos d'objets du bureau ou d'événements mémorables. Nos options de personnalisation vous aident à intégrer textes et images en toute simplicité.",
          "title": "Comment ajouter de l'humour ou des touches personnelles ?"
        },
        "photo-books-retirement-layout-ideas": {
          "content": "Une frise chronologique des étapes de carrière est une excellente structure. Commencez par les débuts et progressez jusqu'à la retraite en mettant en avant les accomplissements clés. Avec notre mise en page une photo par page, chaque jalon reçoit l'attention qu'il mérite, et vous réorganisez les photos facilement pour une histoire fluide.",
          "title": "Quelles idées de mise en page pour le rendre spécial ?"
        },
        "photo-books-retirement-photo-quality": {
          "content": "La qualité des photos est cruciale. Nous recommandons une résolution entre 600 × 600 pixels et 7000 × 7000 pixels pour un rendu net et vibrant. Notre plateforme vous avertit si une image ne répond pas à ces critères, afin que vous puissiez choisir la meilleure option.",
          "title": "Quelle importance a la qualité des photos pour un album de retraite ?"
        },
        "photo-books-retirement-meaningful-gifts": {
          "content": "Les livres photo de retraite sont des cadeaux précieux : ils condensent un parcours professionnel et des liens humains. C'est une manière tangible de revenir sur les réussites et les souvenirs. Chez Mixtiles, nous veillons à offrir un souvenir personnalisé et premium qui sera chéri pendant des années.",
          "title": "Pourquoi ces livres sont-ils des cadeaux si marquants ?"
        },
        "photo-books-fathers-day-great-gift": {
          "content": "Un livre photo est un cadeau idéal pour la Fête des Pères : il rassemble des souvenirs et moments personnels qui célèbrent l'histoire unique de votre papa. Nous proposons de superbes livres reliés pour compiler les instants de famille, voyages et étapes de vie dans un souvenir à garder pour toujours. Matériaux de haute qualité pour un cadeau durable et élégant.",
          "title": "Pourquoi un livre photo est-il un excellent cadeau pour la Fête des Pères ?"
        },
        "photo-books-fathers-day-memories-include": {
          "content": "Incluez un mélange de souvenirs qui montrent différentes facettes de la vie de votre père : photos de bébé, voyages en famille, grands moments. Une photo par page pour que chaque souvenir ait la vedette. Avec nos outils d'édition, recadrez et organisez pour raconter parfaitement votre histoire.",
          "title": "Quels souvenirs inclure ?"
        },
        "photo-books-fathers-day-make-special": {
          "content": "Pour le rendre encore plus spécial, pensez à un thème \"Avant / Maintenant\". Commencez par l'enfance, passez par les moments forts et terminez par des instants récents. Personnalisez la couverture avec une photo marquante et un texte qui résume votre histoire. Mixtiles facilite la création d'un souvenir que Papa chérira.",
          "title": "Comment rendre le livre spécial pour Papa ?"
        },
        "photo-books-fathers-day-involve-children": {
          "content": "Impliquer les enfants ajoute une touche sincère. Encouragez-les à faire des dessins ou à écrire de petits mots à scanner et intégrer. Le cadeau devient un projet de famille. Notre plateforme vous laisse une grande liberté pour créer un livre unique pour la Fête des Pères.",
          "title": "Dois-je impliquer les enfants dans la création du livre ?"
        },
        "photo-books-fathers-day-format-recommended": {
          "content": "Nos livres ont une couverture rigide élégante au fini mat, à la fois durable et raffinée. Contrairement aux albums cuir traditionnels ou aux couvertures souples, nos pages en papier velouté, toucher soie, réduisent les reflets et gardent des couleurs vibrantes. Un rendu premium pour préserver vos souvenirs.",
          "title": "Quel format est recommandé ?"
        },
        "photo-books-fathers-day-who-book-for": {
          "content": "Un livre photo pour la Fête des Pères convient aux nouveaux papas, aux grands‑pères et à toutes les figures paternelles. Qu'il s'agisse d'une première fête ou d'un bel anniversaire de paternité, adaptez le livre à son histoire. Avec des formats de {{v1}} à {{v3}}, choisissez la taille parfaite.",
          "title": "À qui s'adresse ce livre ?"
        },
        "photo-books-fathers-day-how-many-photos": {
          "content": "Nos livres peuvent présenter de 24 à {{max_photos}} photos, avec une photo par page. Assez flexible pour un recueil riche ou concis, selon vos préférences.",
          "title": "Combien de photos ou de pages inclure ?"
        },
        "photo-books-fathers-day-nostalgic-photos": {
          "content": "Bien sûr ! Les photos de famille nostalgiques sont parfaites. Téléversez des images d'au moins 600 × 600 pixels pour un rendu net. Nos impressions premium font revivre ces souvenirs avec des couleurs éclatantes.",
          "title": "Puis-je utiliser des photos de famille anciennes pour le livre de la Fête des Pères ?"
        },
        "photo-books-pet-dog-create-personalized": {
          "content": "Créer un album photo pour votre chien avec Mixtiles, c'est un jeu d'enfant ! Téléversez vos photos préférées sur notre site ou app, et notre plateforme les organise automatiquement en un superbe livre. Vous pouvez ensuite réarranger, recadrer et ajouter vos touches perso. Imprimé sur papier velouté, toucher soie, avec une couverture rigide mate durable — des souvenirs faits pour durer.",
          "title": "Comment créer un album photo personnalisé pour mon chien ?"
        },
        "photo-books-pet-dog-photos-include": {
          "content": "Pour votre album, pensez à des moments variés qui montrent la personnalité de votre chien et vos instants partagés : bêtises du quotidien, jeux, câlins. Téléversez entre 24 et {{max_photos}} photos pour raconter votre histoire en grand.",
          "title": "Quelles photos inclure dans l'album de mon chien ?"
        },
        "photo-books-pet-dog-puppy-family-photos": {
          "content": "Bien sûr ! Mélanger des photos chiot et des photos de famille crée un récit chaleureux. Nous vous encourageons à mêler les étapes de vie de votre compagnon aux moments forts de la famille pour un souvenir complet.",
          "title": "Puis-je mêler photos de chiot et photos de famille ?"
        },
        "photo-books-pet-dog-choose-best-photos": {
          "content": "Choisissez des images de qualité qui racontent quelque chose et suscitent une émotion. Idéalement entre 600 × 600 et 7000 × 7000 pixels. Utilisez nos outils pour recadrer et améliorer afin que chaque page soit impeccable.",
          "title": "Comment sélectionner les meilleures photos de mon chien ?"
        },
        "photo-books-pet-dog-why-make-album": {
          "content": "Un album photo pour votre chien célèbre et préserve votre lien unique. C'est un souvenir personnel pour revivre les moments et jalons marquants. À poser sur la table basse ou à partager : une belle façon d'honorer sa place dans votre vie.",
          "title": "Pourquoi faire un album photo pour mon chien ?"
        },
        "photo-books-pet-dog-templates-design-ideas": {
          "content": "Mixtiles ne propose pas de modèles spécifiques, mais notre création en un tap simplifie tout. Une fois les photos téléversées, elles sont automatiquement organisées dans une mise en page élégante que vous pouvez ajuster. De quoi laisser libre cours à votre créativité pour refléter votre style et l'histoire de votre chien.",
          "title": "Existe‑t‑il des modèles ou des idées de design pour un livre photo de chien ?"
        },
        "photo-books-pet-dog-include-milestones": {
          "content": "Inclure des jalons comme la \"première promenade\" ou le \"premier Noël\" donne de l'épaisseur à l'album. Chaque événement met en lumière la croissance de votre compagnon. Avec une photo par page, chaque étape est célébrée comme il se doit.",
          "title": "Dois‑je inclure des jalons comme \"première promenade\" ou \"premier Noël\" ?"
        },
        "photo-books-pet-dog-gift-idea": {
          "content": "Oui, un album photo personnalisé de votre chien est un cadeau parfait pour tout amoureux des animaux. Au paiement, vous pouvez commander plusieurs exemplaires, identiques à l'original, pour partager ces souvenirs avec vos proches.",
          "title": "Puis‑je offrir l'album de mon chien à un proche ?"
        },
        "photo-books-anniversary-great-gift": {
          "content": "Un livre photo d'anniversaire de rencontre ou de mariage est un cadeau intemporel qui capture votre histoire commune. Chez Mixtiles, nous créons des souvenirs personnalisés qui rassemblent vos meilleurs moments dans un livre relié élégant. Chaque page vous fait revivre des instants chéris — parfait pour célébrer votre amour.",
          "title": "Pourquoi un livre photo est‑il un excellent cadeau d'anniversaire de couple ?"
        },
        "photo-books-anniversary-memories-include": {
          "content": "Mêlez grands jalons et instants du quotidien : première photo ensemble, voyages, célébrations mémorables. Nos outils simples vous aident à tout agencer pour que votre album raconte votre histoire unique.",
          "title": "Quels souvenirs inclure dans un livre anniversaire ?"
        },
        "photo-books-anniversary-how-many-photos": {
          "content": "Vous pouvez inclure de 24 à {{max_photos}} photos. Notre mise en page à une photo par page donne la vedette à chaque souvenir, pour un rendu propre et élégant.",
          "title": "Combien de photos pour un livre anniversaire ?"
        },
        "photo-books-anniversary-everyday-candid-moments": {
          "content": "Bien sûr ! Les moments spontanés du quotidien ajoutent de l'authenticité. Ces instantanés capturent la vraie essence de votre relation. Chez Mixtiles, chaque moment compte.",
          "title": "Dois‑je aussi inclure des moments du quotidien ?"
        },
        "photo-books-anniversary-personal-unique": {
          "content": "Personnalisez votre album avec une couverture marquante et un texte qui résume votre histoire. Recadrez et organisez pour coller à votre narration. Avec nos pages au toucher soyeux, le résultat est aussi beau qu'unique.",
          "title": "Comment rendre un livre anniversaire personnel et unique ?"
        },
        "photo-books-anniversary-any-year-celebration": {
          "content": "Oui, ces livres sont parfaits pour toutes les années, de la première à la cinquantième. Nos couvertures rigides mates mettent en valeur vos souvenirs et les protègent dans le temps.",
          "title": "Convient‑il à n'importe quelle année de célébration ?"
        },
        "photo-books-anniversary-photo-quality": {
          "content": "Pour des tirages nets, utilisez des photos entre 600 × 600 et 7000 × 7000 pixels. Notre plateforme vous alerte si une image est en dessous, afin de choisir une alternative.",
          "title": "Quelle qualité photo pour un album d'anniversaire de couple ?"
        },
        "photo-books-anniversary-tell-love-story": {
          "content": "Organisez vos photos par chronologie ou par thèmes pour refléter votre chemin. Utilisez notre création en un tap pour téléverser et arranger facilement. Avec Mixtiles, vous avez la liberté de composer un album qui raconte magnifiquement votre histoire d'amour.",
          "title": "Comment raconter notre histoire d'amour dans le livre ?"
        },
        "photo-books-mothers-day-perfect-gift": {
          "content": "Un livre photo est un cadeau parfait pour la Fête des Mères : il capture des souvenirs chers dans un objet que l'on feuillette encore et encore. Chez Mixtiles, nous proposons des livres reliés élégants. Contrairement à un album traditionnel, nos livres ont une couverture rigide mate et des pages en papier velouté, toucher soie, pour un cadeau premium que maman adorera.",
          "title": "Pourquoi un livre photo est‑il un cadeau idéal pour la Fête des Mères ?"
        },
        "photo-books-mothers-day-memories-include": {
          "content": "Pour votre livre de la Fête des Mères, mélangez moments de famille, temps forts de vacances et grands événements. Ces souvenirs racontent votre lien. Nos outils d'édition vous permettent d'organiser les photos comme vous le souhaitez pour que chacune brille.",
          "title": "Quels souvenirs mettre dans un livre pour la Fête des Mères ?"
        },
        "photo-books-mothers-day-personalize-book": {
          "content": "Personnaliser votre livre est simple : ajoutez des légendes et petits mots à chaque page pour donner du contexte et de l'émotion. Choisissez une photo spéciale pour la couverture et modifiez le texte pour résumer votre histoire. Un rendu vraiment unique.",
          "title": "Comment personnaliser le livre pour maman ?"
        },
        "photo-books-mothers-day-creative-themes": {
          "content": "Des thèmes créatifs : \"Une année en images\", \"Générations\", ou \"Les moments préférés de maman\". Chaque livre a une mise en page à une photo par page pour un récit clair. Notre plateforme organise même vos photos automatiquement pour un résultat canon en quelques taps.",
          "title": "Quels thèmes créatifs fonctionnent pour un livre de la Fête des Mères ?"
        },
        "photo-books-mothers-day-shared-activities": {
          "content": "Absolument ! Les activités partagées et moments spéciaux sont essentiels : ils capturent l'essence de votre relation. Nos livres mettent ces souvenirs en valeur avec des couleurs vibrantes et une impression de haute qualité.",
          "title": "Dois‑je inclure des activités partagées et des moments spéciaux ?"
        },
        "photo-books-mothers-day-how-far-back": {
          "content": "Aucune règle stricte : mélangez photos récentes et anciennes pour raconter l'histoire sur la durée. Avec Mixtiles, vous pouvez téléverser jusqu'à {{max_photos}} photos — de quoi rassembler une belle sélection.",
          "title": "Jusqu'à quelle époque remonter pour choisir les photos ?"
        },
        "photo-books-mothers-day-quotes-messages": {
          "content": "Oui, ajouter des citations ou des messages est une excellente idée. Qu'il s'agisse d'une phrase préférée de votre mère ou d'un mot qui vous parle, ces ajouts enrichissent l'émotion du livre. Vous pouvez facilement intégrer du texte à côté des images.",
          "title": "Puis‑je ajouter des citations ou des messages touchants ?"
        },
        "photo-books-mothers-day-creation-steps": {
          "content": "Créer un livre personnalisé pour la Fête des Mères est simple : téléversez au moins 24 photos sur notre site ou app. Notre création en un tap les organise pour vous, avec la liberté de personnaliser ensuite. Commandez directement une fois prêt. Besoin d'aide ? Notre équipe support est dispo par e‑mail ou chat en direct.",
          "title": "Quelles sont les étapes pour créer un livre pour la Fête des Mères ?"
        },
        "photo-books-deals-current-available": {
          "content": "Chez Mixtiles, nous proposons régulièrement des offres pour économiser sur vos livres photo. La plupart des remises varient entre 15 % et 20 %, souvent lors d'événements saisonniers, de fêtes ou de campagnes spéciales. Le mieux ? Pas besoin de code : la promo en cours s'applique automatiquement à votre panier lorsqu'elle est active. Commencez votre livre et vous verrez la remise au paiement.\n\nNos livres sont beaux et très simples à créer grâce à notre création en un tap. Téléversez vos meilleurs moments : nous les organisons en un livre prêt à commander — sans édition compliquée (sauf si vous en voulez !).",
          "title": "Quelles sont les offres actuelles sur les livres photo Mixtiles ?"
        },
        "photo-books-deals-apply-promo-code": {
          "content": "Beaucoup d'offres s'appliquent automatiquement, mais il arrive que vous receviez un code promo par e‑mail ou sur les réseaux sociaux. Pour l'appliquer manuellement :<ol><li>Appuyez sur l'icône de menu (☰) en haut de notre site ou app.</li><li>Sélectionnez Code promo.</li><li>Cliquez sur Ajouter un code promo en bas de l'écran.</li><li>Saisissez votre code et validez.</li></ol>C'est tout. Une fois le code appliqué, la remise apparaît instantanément dans votre panier. Si le code ne fonctionne pas, vérifiez sa date de validité et qu'il ne se cumule pas avec une autre offre.",
          "title": "Comment appliquer un code promo pour bénéficier d'une offre ?"
        },
        "photo-books-deals-combine-multiple": {
          "content": "Une seule promotion par commande. Même si nous adorons proposer de bonnes affaires, les réductions sur les livres photo ne sont pas cumulables. Si vous avez plusieurs codes valides, gardez le second pour votre prochain livre.\n\nOn garde tout simple — comme nos livres — pas besoin de jongler avec les codes pour obtenir un bon prix.",
          "title": "Puis‑je cumuler plusieurs offres ou codes ?"
        },
        "photo-books-deals-bigger-orders": {
          "content": "Notre modèle de prix est différent. Chez Mixtiles, nos livres photo ont un prix fixe, quel que soit le nombre de pages. Vous pouvez donc ajouter des souvenirs sans frais supplémentaires.\n\nContrairement à beaucoup de concurrents, nous ne facturons pas à la page. C'est simple et transparent — et il y a moins besoin de remises de volume. Que votre livre ait 20 ou 80 photos, le prix reste le même.",
          "title": "Pourquoi les offres ne deviennent‑elles pas plus avantageuses pour les grosses commandes ?"
        },
        "photo-books-deals-stay-updated": {
          "content": "Pour être informé en premier de nos offres :<ul><li>Inscrivez‑vous à nos e‑mails sur <a href=\"https://www.mixtiles.com/getstarted\" target=\"_blank\" rel=\"noopener noreferrer\">www.mixtiles.com/getstarted</a></li><li>Suivez‑nous sur Instagram et Facebook, où nous partageons des promos exclusives</li></ul>Nos abonnés reçoivent souvent des accès anticipés à des promos limitées. Que vous vouliez imprimer un voyage récent ou préparer un cadeau, restez connecté pour ne rien manquer.",
          "title": "Comment rester informé des prochaines offres ?"
        },
        "photo-books-christmas-why-make": {
          "content": "Créer un livre photo de Noël permet de préserver vos souvenirs de fête dans un objet tangible. Nous proposons de superbes livres reliés pour revivre chaque moment, de la déco du sapin aux dîners en famille. Plus qu'une collection d'images, ce sont des souvenirs qui capturent la chaleur et la joie des fêtes.",
          "title": "Pourquoi faire un livre photo de Noël ?"
        },
        "photo-books-christmas-photos-include": {
          "content": "Incluez des photos qui reflètent l'esprit de vos fêtes : décoration du sapin, ouverture des cadeaux, repas en famille. Ces moments sont au cœur de Noël, et nos livres premium, imprimés sur papier velouté, toucher soie, leur donnent des couleurs vibrantes.",
          "title": "Quelles photos inclure dans un album de Noël ?"
        },
        "photo-books-christmas-theme-book": {
          "content": "Thématiser votre livre de Noël ajoute une touche perso. Des thèmes populaires : \"Pays des merveilles hivernal\" avec paysages enneigés et cocons douillets, ou \"Home for the Holidays\" centré sur les moments familiaux. Avec Mixtiles, arrangez et thématisez vos photos exactement comme vous l'imaginez.",
          "title": "Comment donner un thème à un livre de Noël ?"
        },
        "photo-books-christmas-decorations-captions": {
          "content": "Ajouter des décorations ou des légendes renforce la narration. Nos outils simples vous permettent d'ajouter du texte ou des éléments décoratifs qui complètent vos photos. Bordure festive ou citation chaleureuse : ces touches rendent le livre encore plus spécial.",
          "title": "Dois‑je ajouter des décorations ou des légendes ?"
        },
        "photo-books-christmas-snowy-outdoor-photos": {
          "content": "Bien sûr ! Les photos enneigées ou en extérieur ajoutent variété et profondeur. Notre mise en page une photo par page met chaque détail en valeur, même pour les scènes d'hiver.",
          "title": "Puis‑je inclure des photos d'hiver en extérieur ?"
        },
        "photo-books-christmas-creative-ideas": {
          "content": "Pour une touche créative, pensez aux autocollants et aux citations. Nous proposons des outils pour personnaliser votre livre et y ajouter l'esprit des fêtes. De quoi transformer votre livre en un souvenir unique de Noël.",
          "title": "Quelles idées créatives pour un livre photo de Noël ?"
        },
        "photo-books-christmas-meaningful-gift": {
          "content": "Un livre photo de Noël est un cadeau plein de sens : une collection personnalisée de souvenirs à chérir pendant des années. Avec nos couvertures rigides mates, c'est parfait pour partager vos histoires avec vos proches.",
          "title": "En quoi un livre de Noël fait‑il un cadeau marquant ?"
        },
        "photo-books-christmas-creation-steps": {
          "content": "Créer un livre de Noël avec Mixtiles est simple et intuitif. Choisissez un thème et vos photos préférées. Téléversez au moins 24 images via notre site ou app, et notre création en un tap les organise en un livre prêt à commander. Personnalisez ensuite pour refléter votre histoire unique des fêtes.",
          "title": "Quelles étapes pour créer un livre de Noël ?"
        },
        "photo-books-12x12-sizes-formats": {
          "content": "Nous proposons trois tailles, dont le format {{size_display}} impressionnant. Idéal si vous voulez un rendu fort et spectaculaire. Nos livres {{size_display}} ont une couverture rigide mate élégante, gage de durabilité et de style.",
          "title": "Quels sont les formats et tailles des livres {{size_display}} ?"
        },
        "photo-books-12x12-pages-contain": {
          "content": "Nos livres {{size_display}} peuvent présenter entre 24 et {{max_photos}} de vos meilleurs souvenirs, avec une photo par page pour donner à chaque moment la lumière qu'il mérite. Parfait pour un événement comme pour une collection plus vaste.",
          "title": "Combien de pages peut contenir un livre {{size_display}} ?"
        },
        "photo-books-12x12-cover-materials": {
          "content": "Nous fabriquons nos livres {{size_display}} avec des matériaux premium : un papier velouté, toucher soie, qui rehausse la vivacité des photos. La couverture rigide est protégée par un film mat fin pour plus de solidité et une touche de sophistication.",
          "title": "Quels matériaux de couverture pour les livres {{size_display}} ?"
        },
        "photo-books-12x12-lay-flat-hardcover": {
          "content": "Nos livres sont à couverture rigide, pour préserver durablement vos souvenirs. Ils ne sont pas à ouverture à plat (lay‑flat), mais la couverture protège et présente vos photos avec élégance.",
          "title": "Les livres {{size_display}} sont‑ils lay‑flat ou à couverture rigide ?"
        },
        "photo-books-12x12-good-for": {
          "content": "Un livre {{size_display}} est idéal en livre de table basse : il attire le regard et invite à feuilleter vos moments favoris. Son grand format met en valeur les images détaillées et raconte votre histoire avec force.",
          "title": "À quoi sert particulièrement un livre {{size_display}} ?"
        },
        "photo-books-12x12-compare-smaller": {
          "content": "Par rapport aux tailles plus petites, le {{size_display}} offre une toile plus vaste pour vos photos — parfait pour les images détaillées et les récits complets. Chaque détail compte et se voit.",
          "title": "Comment les livres {{size_display}} se comparent‑ils aux formats plus petits ?"
        },
        "photo-books-12x12-price-range": {
          "content": "En raison de sa taille et des matériaux premium, le livre {{size_display}} est généralement plus cher que les formats plus compacts. Mais l'investissement vaut le coup pour un écrin de grande qualité à fort impact visuel.",
          "title": "Quelle fourchette de prix pour les livres {{size_display}} ?"
        },
        "photo-books-12x12-professional-portfolio": {
          "content": "Absolument ! Le format {{size_display}} convient très bien aux albums professionnels ou portfolios. Avec une impression premium et des réglages personnalisables, c'est une présentation soignée et impressionnante de vos projets.",
          "title": "Puis‑je utiliser le format {{size_display}} pour un portfolio ?"
        },
        "photo-books-8x8-what-makes-special": {
          "content": "Un livre {{size_display}} est un album carré et compact qui met joliment en valeur vos souvenirs. Chez Mixtiles, nos livres allient couverture rigide mate et pages en papier velouté, toucher soie. Ce format est parfait pour ceux qui veulent un livre maniable sans compromis sur la qualité.",
          "title": "Qu'est‑ce qu'un livre {{size_display}} et qu'a‑t‑il de spécial ?"
        },
        "photo-books-8x8-mix-portrait-landscape": {
          "content": "Oui, vous pouvez mélanger photos portrait et paysage dans votre livre {{size_display}}. Nos outils vous permettent de zoomer, recadrer et réorganiser. Une photo par page pour donner la vedette à chaque image.",
          "title": "Puis‑je mixer des photos portrait et paysage dans un {{size_display}} ?"
        },
        "photo-books-8x8-cover-options": {
          "content": "Nos livres {{size_display}} ont une couverture rigide mate premium. Personnalisez‑la en choisissant une photo spéciale et en modifiant le texte \"Happy Moments\" pour le rendre à votre image. Une touche perso qui résume votre histoire dès la couverture.",
          "title": "Quelles options de couverture pour les livres {{size_display}} ?"
        },
        "photo-books-8x8-good-occasions": {
          "content": "Le format {{size_display}} est idéal pour de nombreuses occasions : réunions de famille, voyages, mariages ou jalons de vie. Sa taille compacte en fait un souvenir parfait à offrir et à partager.",
          "title": "Pour quelles occasions un {{size_display}} est‑il adapté ?"
        },
        "photo-books-8x8-pages-have": {
          "content": "Nos livres {{size_display}} peuvent accueillir de 24 à {{max_photos}} pages, pour mettre en scène un éventail de souvenirs. Cette flexibilité vous permet de raconter votre histoire comme vous l'entendez.",
          "title": "Combien de pages un {{size_display}} peut‑il avoir ?"
        },
        "photo-books-8x8-square-format-display": {
          "content": "Oui, le {{size_display}} est au format carré, facile à exposer sur une table, une étagère ou un bureau. Sa taille compacte et son design soigné s'intègrent partout.",
          "title": "Les livres {{size_display}} sont‑ils carrés et faciles à exposer ?"
        },
        "photo-books-8x8-templates-styles": {
          "content": "Chez Mixtiles, la création en un tap organise automatiquement vos photos en une mise en page cohérente. Nous ne proposons pas plusieurs modèles, mais notre interface permet d'ajuster l'ordre et le recadrage pour obtenir le style qui vous convient.",
          "title": "Quels modèles ou styles sont disponibles pour les {{size_display}} ?"
        },
        "photo-books-8x8-why-choose": {
          "content": "Choisir le {{size_display}} offre le bon équilibre entre portabilité et mise en valeur. Assez grand pour sublimer vos photos, assez compact pour être manipulé et rangé facilement. Un format polyvalent qui s'adapte à tous les contextes.",
          "title": "Pourquoi choisir un {{size_display}} plutôt qu'une autre taille ?"
        },
        "photo-books-recipe-what-is": {
          "content": "Un livre photo de recettes est une façon unique et personnelle de compiler vos recettes préférées avec de belles photos. Comme un livre de cuisine, il met en avant les recettes et l'esthétique des plats. Chez Mixtiles, nos livres reliés élégants transforment votre collection culinaire en souvenir. Avec nos outils simples, composez un livre qui raconte votre parcours en cuisine et offre un plaisir visuel à chaque page.",
          "title": "Qu'est‑ce qu'un livre photo de recettes et à quoi sert‑il ?"
        },
        "photo-books-recipe-old-family-recipes": {
          "content": "Intégrer d'anciennes recettes familiales est une superbe manière de préserver vos traditions culinaires. Scannez les recettes manuscrites et téléversez‑les comme images. Notre plateforme permet de les placer aux côtés de photos des plats finis ou de la famille en train de cuisiner, pour un lien tendre entre passé et présent.",
          "title": "Comment inclure de vieilles recettes de famille ?"
        },
        "photo-books-recipe-themes": {
          "content": "Les possibilités de thèmes sont infinies : recettes de fêtes pour l'esprit des grandes tablées, livre dédié aux desserts avec photos gourmandes, ou encore recettes petit budget pour cuisiner malin. Quel que soit le thème, nos livres sont le support parfait pour votre vision culinaire.",
          "title": "Quels thèmes pour un livre photo de recettes ?"
        },
        "photo-books-recipe-organize": {
          "content": "Organisez selon vos préférences : chronologiquement pour refléter votre évolution, ou par catégories (entrées, plats, desserts). Sur Mixtiles, vous réarrangez facilement pages et photos pour un livre aussi pratique que beau.",
          "title": "Comment organiser les recettes dans le livre ?"
        },
        "photo-books-recipe-layout-details": {
          "content": "Chaque recette devrait inclure un titre clair, la liste des ingrédients, des étapes détaillées et des photos. Nos livres offrent une mise en page à une photo par page pour mettre en valeur chaque plat. Ajoutez aussi des notes perso ou astuces pour plus d'engagement.",
          "title": "Quels éléments de mise en page pour chaque recette ?"
        },
        "photo-books-recipe-cooking-process-photos": {
          "content": "Absolument ! Ajouter des photos des étapes ou du plat fini enrichit votre livre. Nos impressions premium sur papier velouté, toucher soie, donnent vie aux couleurs et aux détails pour une lecture encore plus plaisante.",
          "title": "Puis‑je ajouter des photos du processus de cuisine ou des plats finis ?"
        },
        "photo-books-recipe-family-heirloom": {
          "content": "Oui, un livre photo de recettes est un formidable héritage familial. Il préserve l'histoire culinaire de votre famille et se transmet de génération en génération. En capturant recettes et anecdotes, vous créez un souvenir intemporel. Nos couvertures rigides mates garantissent la durabilité.",
          "title": "Un livre photo de recettes peut‑il devenir un héritage familial ?"
        },
        "photo-books-recipe-make-engaging": {
          "content": "Pour un livre captivant, ajoutez notes personnelles, anecdotes ou astuces à chaque recette. Ces éléments donnent du sens et rendent la lecture plus interactive. Personnalisez pour refléter votre parcours culinaire et offrir une expérience mémorable.",
          "title": "Comment rendre le livre vivant et engageant ?"
        }
      },
      "fullscreen_title": "Des tirages photo de qualité professionnelle, directement depuis votre téléphone portable",
      "fullscreen_title_desktop": "Des tirages photo de qualité professionnelle",
      "made_in_canada": "Fabriqué au Canada",
      "main_button_cta": "Acheter maintenant",
      "photo_wall": {
        "subtitle": "Choisissez le style idéal pour votre maison",
        "title": "Créez un mur de photos en quelques clics"
      },
      "secondary_title_1": "Dites adieu au marteau et aux clous",
      "secondary_title_1_desktop": "Déplacez, repositionnez à volonté",
      "secondary_title_2": "Ajustement parfait",
      "secondary_title_3": "Zéro trace, zéro dégât",
      "meet_magnetic_hanging": "Fixation magnétique",
      "seen-on": "Comme vu sur",
      "seen-on-desktop": "Comme vu sur",
      "simple_price": {
        "subtitle": "Nos prix sont transparents, sans frais supplémentaires, et la livraison est toujours gratuite.",
        "title": "Un seul prix, quel que soit le nombre de pages"
      },
      "simple_price_tiers": {
        "from_label": "À partir de",
        "subtitle": "Nos livres ont des prix simples selon la taille et le nombre de pages, livraison gratuite incluse.",
        "title": "Prix Simples, Sans Surprises"
      },
      "title": "Des murs de photos réinventés",
      "try_now": {
        "continue": "Continuez votre livre photo",
        "subtitle": "Concevez votre livre photo en quelques clics et voyez-le prendre vie en 3D",
        "title": "Vos livres Photo en toute simplicité",
        "design_subtitle": "Transformez vos voyages en superbes livres photo en quelques clics",
        "design_title": "Livres de Voyage Faciles",
        "life_events_subtitle": "Transformez les grands moments de votre vie en livres photo en quelques clics.",
        "life_events_title": "Un beau livre pour chaque grande étape",
        "create_now": "Créer maintenant"
      },
      "email_signup": {
        "title": "Soyez les premiers informés — offres, actualités et idées déco.",
        "email_label": "Adresse e-mail",
        "terms_text": "En vous inscrivant, vous acceptez les Conditions d'utilisation et la Politique de confidentialité de Mixtiles.",
        "success_message": "Merci pour votre abonnement"
      }
    },
    "login": {
      "last_used": "Dernier utilisé",
      "continue_with": "Continuer avec",
      "create_account_error": "Une erreur s'est produite lors de la création du compte",
      "error_dialog": {
        "incorrect_email_or_code_message": "L'e-mail ou le code saisi est incorrect. Veuillez réessayer de saisir le code ou votre e-mail.",
        "incorrect_email_or_code_title": "E-mail ou code incorrect",
        "login_unsuccessful_message": "Veuillez réessayer ou contacter le support",
        "login_unsuccessful_title": "Connexion échouée",
        "too_many_incorrect_attempts_message": "Veuillez vérifier votre e-mail pour débloquer votre compte.",
        "too_many_incorrect_attempts_title": "Trop de tentatives incorrectes"
      },
      "email_capture_placeholder": "Saisissez votre e-mail",
      "email_code": {
        "code_sent": "Le code a été envoyé à votre e-mail",
        "code_sent_detailed": "Un e-mail contenant le code a été envoyé à {{email}}",
        "resend_code": "Renvoyer le code",
        "resend_code_countdown": "Renvoyer dans {{seconds}} s",
        "enter_code": "Saisir le code"
      },
      "login": "S'identifier",
      "login_message": "{{v1}} pour sauvegarder votre progression et suivre l'état de vos commandes",
      "login_or_sign_up": "S'identifier ou S'inscrire",
      "login_successfully": "Super ! Vous êtes connecté",
      "no_email_error": "Vous devez donner accès à votre adresse courriel pour créer un compte.",
      "register_successfully": "Bienvenue ! Inscription terminée",
      "restored_photo": "Votre photo enregistrée a été restaurée",
      "restored_photos": "Vos photos enregistrées ont été restaurées",
      "restricted": {
        "title": "Connectez-vous pour voir vos commandes"
      },
      "sign_out": "Se déconnecter",
      "sign_up": "Inscrivez-vous",
      "start_your_design_journey": "Commencer à créer",
      "terms_of_use": {
        "and": "et",
        "privacy_policy": "Politique de Confidentialité",
        "terms_of_use": "Conditions générales de vente",
        "terms_of_use_intro": "En vous inscrivant, vous acceptez nos"
      },
      "verify_email_dialog": {
        "button": "Je le ferai plus tard",
        "content": "Nous avons envoyé un e-mail à {{v1}} pour vérifier votre identité et vous permettre d'accéder à l'historique de vos commandes.",
        "title": "Vérifiez votre boîte de réception"
      }
    },
    "logout": {
      "signed_out_successfully": "Déconnexion réussie",
      "signed_out_successfully_subtitle": "Reconnectez-vous pour voir vos photos enregistrées"
    },
    "multi_product_homepage": {
      "photo_walls_title": "Galerie murale",
      "photo_walls_subtitle": "Transformez vos photos en déco murale",
      "photo_books_subtitle": "Créez votre livre en quelques clics",
      "pet_portraits_subtitle": "Des portraits artistiques pleins d'humour",
      "shop_now": "Acheter maintenant",
      "continue_designing": "Reprendre votre projet",
      "explore_now": "Découvrir",
      "download": "Télécharger",
      "app_title": "La nouvelle application Mixtiles",
      "app_subtitle": "Nous transformons automatiquement vos plus beaux moments en créations photo uniques.",
      "app_store_badge": "Télécharger dans l'App Store",
      "get_app_title": "Téléchargez la nouvelle app Mixtiles",
      "new_products_title": "Découvrez nos nouveautés",
      "desktop_new_products_title": "Produits",
      "new_products": {
        "caricature": "Caricatures",
        "the_studio": "Portraits studio"
      },
      "best_place_title": "Le meilleur choix pour imprimer vos photos",
      "stats": {
        "rating_caption": "156 000+ avis",
        "customers_caption": "Clients satisfaits"
      },
      "desktop_stats": {
        "photos_printed_caption": "Photos imprimées"
      }
    },
    "my_orders": {
      "active_orders": "Commandes en cours",
      "completed_orders": "Commandes terminées",
      "no_orders_button": "Choisissez des photos",
      "no_orders_title": "On dirait que vous n'avez encore passé aucune commande.",
      "resend_email": "Renvoyer l'e-mail",
      "verify_email": "Vérifiez votre adresse e-mail"
    },
    "new_email_capture": {
      "a_box_of_mixtiles": {
        "subtitle": "Je choisis les photos à offrir",
        "title": "Une boîte de Mixtiles",
        "tiles_or_book": "Tiles ou un Livre Photo"
      },
      "agree_to_emails": "J'accepte de recevoir des informations et offres promotionnelles",
      "agree_to_emails_sign_now": "S'inscrire maintenant pour recevoir des offres exclusives, vous inspirer et découvrir nos nouveaux produits.",
      "attribution": {
        "channels": {
          "email": "E-mail",
          "facebook": "Facebook",
          "flyer": "Prospectus",
          "friend": "Amis",
          "game": "Jeu mobile",
          "google": "Google",
          "instagram": "Instagram",
          "other": "Autre",
          "pinterest": "Pinterest",
          "snapchat": "Snapchat",
          "stacey_solomon": "Stacey Solomon",
          "rebecca_judd": "Rebecca Judd",
          "tammin_sursok": "Tammin Sursok",
          "tia_mowry": "Tia Mowry",
          "tiktok": "TikTok",
          "tv": "TV",
          "youtube": "Youtube",
          "airport": "Aéroport",
          "podcast": "Podcast",
          "shorts": "Shorts",
          "twitter": "Twitter"
        },
        "help_us_improve": "Aidez-nous à progresser ! ",
        "sub_options": {
          "influencer": "Un influenceur",
          "not_sure": "Je ne suis pas certain.e",
          "paid_ad": "Une publicité"
        },
        "title": "Comment as-tu connu Mixtiles ?"
      },
      "continue": "Continuer",
      "disagree_to_emails": {
        "emphasized": "ne voulez pas",
        "text": "Cochez cette case si vous {{emphasized}} recevoir des messages publicitaires de notre part"
      },
      "email_placeholder": "Quel est votre adresse e-mail ?",
      "for_gift": "Pour quelqu'un d'autre",
      "for_gift_subtitle": "J'achète un cadeau",
      "for_me": "Pour moi",
      "for_me_subtitle": "Je décore ma maison",
      "gift_card": {
        "subtitle": "Je les laisse choisir leurs photos",
        "title": "Une carte-cadeau"
      },
      "gift_question": "Quel type de cadeau ?",
      "intro": {
        "title": "Bienvenue chez Mixtiles. Commençons !"
      },
      "lets_create": "Mettons au point un superbe cadeau",
      "name_placeholder": "Quel est votre nom ?",
      "privacy_disclaimer": "En continuant vous indiquez avoir lu et accepté nos {{v1}} & {{v2}}",
      "sms_privacy_disclaimer_consent": "En saisissant votre numéro, vous acceptez de recevoir des offres par SMS et applications de messagerie, conformément à notre Politique de Confidentialité. Désabonnez-vous à tout moment en répondant STOP ou via le lien de désinscription.",
      "sms_step_label": "Quel est votre numéro ?",
      "sms_step_title": "Recevez des offres et des ventes exclusives sur votre téléphone",
      "title": "Bonjour, {{v1}} !",
      "title_no_name": "Bonjour !",
      "who_for": "C'est pour qui ?",
      "sms_privacy_disclaimer": "En saisissant votre numéro de téléphone, vous acceptez de recevoir des messages marketing au numéro fourni. Le consentement n'est pas une condition d'achat. Des frais de messagerie et de données peuvent s'appliquer. La fréquence des messages varie. Répondez HELP pour obtenir de l'aide ou STOP pour annuler. Consultez nos {{v1}} et {{v2}} "
    },
    "order": {
      "canada_tariff_notice_bag": "Toiles et livres photo exemptés de taxe",
      "canada_tariff_notice_tiles": "Les toiles sont exemptées de taxe",
      "add_photos": "Ajouter des photos",
      "add_photos_count": "Ajouter {{v1}} photos",
      "add_photos_single": "Ajouter 1 photo",
      "add_to_bag": "Ajouter au panier",
      "art": "Art",
      "art_orientation_warning": {
        "checkout": {
          "label": {
            "singular": "Conseil : cette œuvre se présente mieux en mode portrait."
          }
        }
      },
      "checkout": {
        "add_address": "Ajouter une adresse",
        "add_gift_note": "Ajouter un message personnel",
        "add_gift_note_options": {
          "close": "Fermer",
          "description": "Nous ajouterons ce message personnel à votre envoi (et le prix ne sera pas visible)",
          "edit_note": "Modifier ou supprimer le message",
          "edit_options": {
            "dismiss": "Ignorer",
            "edit": "Modifier le texte",
            "remove": "Supprimer le message personnel"
          },
          "header": "Ajouter un message personnel",
          "placeholder": [
            "Salut,",
            "",
            "J'espère que tu aimes ces",
            "moments autant que moi !",
            "",
            "Bisous,",
            "Dominique"
          ],
          "start_writing": "Commencer à écrire"
        },
        "add_payment": "Saisir un mode de paiement",
        "add_payment_options": {
          "credit_card_ends_with": "Finit par {{v1}}",
          "paying_with": "Payez avec {{v1}}"
        },
        "are_you_sure": "Confirmez-vous l'annulation ?",
        "change_info": "Modifier",
        "confirm_button_text_gdpr": "Confirmer et Payer",
        "confirm_button_text_non_gdpr": "Passer commande",
        "gift_note_added": "Message ajouté",
        "minimum_order_fee": {
          "description": "Montant minimal requis : {{v1}}. S'il n'est pas atteint, nous devons hélas facturer la différence.",
          "title": "Frais additionnels - Montant minimal de commande"
        },
        "no_go_back": "Non, revenir en arrière",
        "payment_errors": {
          "add_new_card": "Ajouter une nouvelle carte",
          "authentication_failed_text": "On n'a pas pu authentifier votre carte. Ajoutez-en une nouvelle et essayez à nouveau.",
          "authentication_failed_title": "Échec de l'authentification",
          "card_declined_text": "On est désolés, le paiement a été refusé avec cette carte. Essayez avec une nouvelle carte.",
          "card_declined_text_1": "Votre carte a été refusée. Vérifiez les informations de la carte.",
          "card_declined_text_2": "Si tout est correct, contactez votre banque et réessayez.",
          "card_declined_title_2": "Échec du paiement",
          "charge_failed_text": "On est désolés, on n'a pas pu effectuer le prélèvement pour cette commande. Ajoutez une nouvelle carte et essayez à nouveau.",
          "charge_failed_title": "Échec du prélèvement",
          "incomplete_photo_wall": {
            "missing_photos_plural": "Il manque {{v1}} photos à ton mur photo",
            "missing_photos_singular": "Il manque 1 photo à ton mur photo"
          },
          "invalid_email_text": "Saisis à nouveau ton adresse e-mail pour finaliser ta commande.",
          "invalid_email_title": "Saisis ton adresse e-mail",
          "no_charge_text": "Pas de soucis, aucun prélèvement n'a été effectué",
          "no_tiles_selected": "Aucun cadre choisi !",
          "oops_order_failed": "Oups, la commande a échoué",
          "order_error_text": "Nous n'avons malheureusement pas pu finaliser votre commande. Vous pouvez réessayer ou nous contacter.",
          "order_error_title": "Échec de la commande",
          "payment_error_text": "On n'a malheureusement pas pu finaliser votre commande en raison d'une erreur avec le paiement. Vous pouvez réessayer ou nous contacter.",
          "payment_error_title": "Échec du paiement",
          "uploads_failed_text": "On a eu des problèmes lors de l'ajout de certaines de vos photos. Veuillez essayer de les télécharger à nouveau.",
          "order_price_calculation": {
            "subtitle": "Veuillez actualiser la page. Ne vous inquiétez pas, vos photos seront sauvegardées.",
            "title": [
              "Désolé, nous avons eu un problème",
              "lors du calcul du prix"
            ]
          }
        },
        "payment_methods": "Moyens de paiement",
        "payment_summary_rows": {
          "add_many_more_to_get_discount": "Ajoutez encore {{v1}} cadres pour avoir {{v2}}% de remise sur toute la commande.",
          "add_more_to": {
            "get_more_many": "Ajoutez {{v1}} cadres pour en avoir {{v2}} gratuitement !",
            "get_more_one": "Ajoutez {{v1}} cadres pour en avoir un gratuitement !"
          },
          "add_one_more_to_get_discount": "Ajoutez encore 1 cadre pour avoir {{v1}}% de remise sur toute la commande.",
          "add_one_to": {
            "get_more_many": "Ajoutez-en 1 pour en avoir {{v2}} gratis!",
            "get_more_one": "Ajoutez-en 1 pour en avoir 1 gratis!"
          },
          "are_free": "dont {{v1}} gratuitement",
          "base_price_many": "{{v1}} cadres, {{v2}} chacun",
          "bundle_action": {
            "add_another_many": "ajoutez {{v1}} cadres pour une réduction supplémentaire !",
            "add_another_one": "ajoutez 1 cadre pour une réduction supplémentaire !",
            "add_many": "ajoutez encore {{v1}} cadres pour bénéficier de la promotion !",
            "add_many_short": "encore {{v1}} pour l'offre",
            "add_one": "ajoutez encore 1 cadre pour bénéficier de la promotion !",
            "add_one_short": "encore 1 pour l'offre",
            "get_next_bundle": "obtenez-en {{v1}} pour {{v2}}",
            "perfect": "Parfait ! Vous avez économisé {{v1}}."
          },
          "bundle_change_to_size": "Changez la taille pour {{v1}} pour utiliser le code promo",
          "buy_over_percent_off_orders": "{{v1}}% de réduction sur commandes",
          "buy_over_percent_off_orders_over_price": "{{v1}}% de réduction pour tout achat supérieur à {{v2}}",
          "buy_over_price_applied": "Génial, vous économisez {{v1}}%",
          "buy_over_price_applied_saved": "Génial, vous économisez {{v1}}",
          "discount_percentage_literal": "Vous économisez {{v1}}%",
          "buy_over_price_buy_more": "Achetez encore {{v1}} pour bénéficier de la réduction",
          "buy_over_price_buy_more_short": "ajoutez {{v1}} pour la remise",
          "buy_over_tier": "{{v1}}% de remise dès {{v2}}",
          "buy_over_tiers_pair": "{{v1}} • {{v2}}",
          "buy_x_get_y": "{{v1}} achetées, {{v2}} gratis",
          "buy_x_get_y_action": {
            "get_more_many": "Vous pouvez ajouter {{v1}} cadres gratuits.",
            "get_more_one": "Vous pouvez ajouter 1 cadre gratuit.",
            "saved": "Génial, vous avez économisé {{v1}}!",
            "yay_get_many": "Youpi, vos {{v1}} prochains cadres sont gratuits !",
            "yay_get_one": "Youpi, votre prochain cadre est gratuit !"
          },
          "can_add_free_tiles": "Vous pouvez ajouter {{v1}} cadres gratuits !",
          "can_add_one_free_tile": "Vous pouvez ajouter 1 autre cadre gratuit !",
          "canvas_tile": "1 cadre toile",
          "canvas_tiles": "{{v1}} cadres toile",
          "color_tiles": "{{v1}} cadres {{color}}",
          "delivery_by": "Livraison le",
          "discount": "Remise",
          "discount_off_over_price": "{{v1}}% de réduction pour tout achat supérieur à {{v2}}",
          "discount_off_over_price_short": "-{{v1}}% dès {{v2}}",
          "discount_percentage": "{{v1}}% de réduction",
          "discounts_applied": "{{v1}} appliqué",
          "eligible_free_shipping": "Commande éligible à la livraison gratuite",
          "eligible_free_shipping_over": "Bénéficiez de la livraison gratuite pour toute commande supérieure à {{v1}}",
          "free": "GRATUIT",
          "free_shipping": "Livraison gratuite",
          "free_shipping_over": "Livraison gratuite dès {{v1}}",
          "free_tiles_many": "{{v1}} cadres gratuits",
          "free_tiles_single": "1 cadre gratuit",
          "is_free": "dont 1 est gratis",
          "all_free": "gratuit",
          "many_tiles": "{{v1}} cadres",
          "mixed_frames": "cadres mixtes",
          "mixed_sizes_and_frames": "tailles et cadres mixtes",
          "more_tiles_many": "{{v1}} cadres de plus",
          "more_tiles_one": "1 cadre de plus",
          "more_tiles_with_each_price": "{{v1}} cadres de plus, {{v2}} chacun",
          "one_color_tile": "1 cadre {{color}}",
          "one_tile": "1 cadre",
          "photo_book_description_plural": "Livres Photo ({{v1}} pages)",
          "photo_book_description_singular": "Livre Photo ({{v1}} pages)",
          "sales_tax": "Taxes",
          "select_more_tiles_many": "Choisissez {{v1}} cadres de plus",
          "select_more_tiles_one": "Choisissez 1 cadre de plus",
          "select_some_tiles": "Choisissez des photos",
          "shipping": "Livraison",
          "subtotal": "Sous-total",
          "tax": "Taxes",
          "tiles_count": "{{v1}} cadres",
          "tiles_size_many": "{{v1}} cadres pour {{v2}}",
          "total": "Total",
          "wall_sign": "enseigne murale",
          "wall_signs": "enseignes murales",
          "wide_frame_tile": "1 cadre à large bordure {{color}}",
          "wide_frame_tiles": "{{v1}} cadres à large bordure {{color}}",
          "will_be_free_many": "{{v1}} seront gratuites !",
          "will_be_free_one": "Une sera gratuite !",
          "creditUsed": "Crédit",
          "discount_percentage_automatic": "{{v1}}% de réduction sur les livres photo",
          "import_fee": "Frais d'Importation",
          "international_taxes": "Taxes Locales",
          "many_books": "{{v1}} livres,{{v2}}"
        },
        "promo": {
          "cancel": "Annuler le code promo",
          "free_tiles": "Cadres gratuits",
          "free_books": "Livres photo gratuits",
          "title": "Code promo",
          "yes_remove": "Oui, retirer le code promo"
        },
        "shipping_options": {
          "calculating_delivery_date": "Calcul de la date de livraison...",
          "delivery_by": "Livraison le {{v1}}",
          "express_new_version": "Livraison Express - {{v1}}",
          "express_name": "Livraison Express",
          "priority": "Livraison prioritaire - {{v1}}",
          "priority_name": "Livraison prioritaire",
          "standard": "Livraison standard",
          "estimated_delivery": "Est. {{v1}}"
        },
        "tokushoho_disclaimer": "返品・キャンセル条件／特定商取引法に基づく表記",
        "gift_card_available_credits": "{{v1}} disponible",
        "gift_card_credits": "Crédits Carte Cadeau",
        "gift_card_remove_title": "Êtes-vous sûr de vouloir supprimer votre carte cadeau ?"
      },
      "add_product": "Ajouter un produit",
      "cart_title": "Mon panier",
      "cart_volume_discount": "REMISE VOLUME",
      "cart_add_promo": "Ajouter promo",
      "cart_change_promo": "Changer promo",
      "cart_free_shipping_applied": "Livraison gratuite appliquée",
      "cart_bag": "Panier",
      "empty_bag_title": "Votre panier est vide",
      "empty_bag_cta": "Acheter maintenant",
      "cart_edit": "Modifier",
      "cart_header": {
        "photo_book": "Livre Photo",
        "tiles_one": "1 Cadre",
        "tiles_other": "{{count}} Cadres"
      },
      "cart_summary": {
        "tiles_one": "{{count}} cadre",
        "tiles_other": "{{count}} cadres",
        "wall_signs_one": "{{count}} enseigne murale",
        "wall_signs_other": "{{count}} enseignes murales",
        "with_size": "{{item}}, {{size}}",
        "frame_breakdown_row_one": "{{count}} {{frame}} cadre, {{size}}",
        "frame_breakdown_row_many": "{{count}} {{frame}} cadres, {{size}}",
        "canvas_breakdown_row": "{{count}} {{frame}}, {{size}}",
        "frame_tiles_one": "{{count}} {{frame}} cadre",
        "frame_tiles_many": "{{count}} {{frame}} cadres",
        "canvas_tiles": "{{count}} {{frame}}",
        "combined_no_size": "{{tiles}} et {{signs}}",
        "mixed_sizes_lower": "tailles mixtes",
        "mixed_frames": "cadres mixtes",
        "photo_book": "Livre photo, {{size}}",
        "book_with_pages": "Livre, {{size}}, {{pageCount}} pages"
      },
      "checkout_button_text": "Aller en caisse",
      "choose_from_phone": "Choisir depuis votre smartphone",
      "done": {
        "confirmation_email": "On vous envoie un e-mail de confirmation dans quelques minutes",
        "delivery_time": "Vous aurez votre commande pour le {{v1}}",
        "next": "Suivant",
        "please_hold": "Super ! Encore un p'tit instant, le temps de finaliser la commande.",
        "will_receive_email": "Vous recevrez sous peu un e-mail de confirmation à",
        "woohoo": "Emballé, c'est pesé !"
      },
      "faces_cropped_warning": {
        "cart_cta": "Revoir & corriger",
        "cart_label": "Visage recadré.",
        "cta": {
          "change_size": "Changer de taille",
          "crop": "Recadrer"
        },
        "label": "Certains visages ont été rognés.",
        "notification": {
          "change_size": {
            "cta": "Annuler",
            "title": "Le cadre a été changé en {{size}}"
          },
          "crop": {
            "cta": "Annuler",
            "title": "Votre photo a été recadrée"
          }
        }
      },
      "filters": {
        "dramatic": "Dramatique",
        "noir": "Noir",
        "none": "Original",
        "painting": "Aquarelle",
        "painting2": "Aquarelle 2",
        "pencil": "Dessin",
        "pencil2": "Dessin 2",
        "silver": "Argenté",
        "sketch": "Croquis",
        "sketch2": "Croquis 2",
        "vivid": "Intense",
        "winter": "Froid",
        "b_n_w": "N&B",
        "b_n_w2": "N&B2",
        "original": "Original",
        "vivid2": "Vivid 2"
      },
      "frame_colors": {
        "black": "Noir",
        "none": "Sans cadre",
        "red_ash_wood": "Noyer",
        "white": "Blanc",
        "wood": "Bois de Chêne"
      },
      "frame_presets": {
        "earthy_blend": "Mix Nature",
        "classic_blend": "Mix Classique",
        "harmony_mix": "Mix Harmonie"
      },
      "import_from_google_photos": "Importer depuis Google Photos",
      "low_quality_warning": {
        "action_keep": "Choisir quand même",
        "action_remove": "Supprimer de la commande",
        "banner": {
          "cta": "Valider les photos",
          "text": "Ces photos sont en dessous de la résolution recommandée, elles peuvent paraître floues à l'impression.",
          "title": "Réviser les photos à faible résolution"
        },
        "text": "Cette photo est en fait trop petite. Le résultat sera sûrement flou !",
        "title": "Mauvaise qualité d'image",
        "warning": {
          "cta": "Remplacer",
          "cta_try_in_size": "Essayez la taille {{sizeName}}",
          "label": "Photo à faible résolution"
        }
      },
      "materials": {
        "canvas": "Toile",
        "classic": "Avec bordure",
        "frameless": "Sans bordure",
        "wide_frame": "Cadre à large bordure",
        "sticker": "Sticker"
      },
      "materials_detailed_descriptions": {
        "canvas": "Toile de première qualité pour un aspect plus noble. Imprimé sur du coton extensible, avec fixation magnétique facile.",
        "classic": "Un look classique et haut de gamme. Imprimé sur un papier de qualité supérieure, avec fixation magnétique facile.",
        "frameless": "Un design minimaliste et moderne. Imprimé sur un papier de qualité supérieure, avec fixation magnétique facile.",
        "wide_frame": "Une élégance audacieuse pour un look haut de gamme. Imprimé sur un papier de qualité supérieure, avec fixation magnétique facile."
      },
      "materials_plural": {
        "classic": "Cadres",
        "wide_frame": "Cadres à large bordure"
      },
      "mats": {
        "deep": "Large",
        "medium": "Moyenne",
        "none": "Aucune",
        "shallow": "Fine",
        "heart": "Cœur",
        "round": "Rond"
      },
      "promo_code_errors": {
        "messages": {
          "already_a_user": "On dirait que ce code n'est que pour les nouveaux clients. Désolé !",
          "already_registered": "Ce code a déjà été ajouté",
          "default": "On dirait que ce code n'existe pas. Désolé !",
          "expired": "On dirait que ce code a déjà expiré. Désolé !",
          "non_existing": "On dirait que ce code n'existe pas. Désolé !",
          "quantity_exceeded": "Ce code a déjà été utilisé ! Inutile de le saisir à nouveau. Retournez simplement sur l'appareil où vous l'avez entré la première fois, allez au paiement, et vos cadres gratuits seront disponibles.",
          "redemptions_per_customer_exceeded": "Oups ! On dirait que ce code a déjà été utilisé et n'est plus valide. Désolé !",
          "self_referral": "Ce code est pour les amis que vous invitez sur Mixtiles.",
          "server_error": "On a eu un souci en vérifiant votre code. Essayez à nouveau ou contactez-nous."
        },
        "titles": {
          "gift_card_empty": "Cette carte cadeau a été entièrement utilisée",
          "gift_card_inactive": "Cette carte cadeau n'est pas active"
        }
      },
      "styles": {
        "mixed_styles": "Mixte"
      },
      "tile_actions": {
        "adjust": "Recadrer",
        "remove": "Supprimer",
        "remove_photo": "Supprimer la photo",
        "replace": "Remplacer la photo",
        "replace2": "Remplacer",
        "replace_subtitle": "Choisis une photo existante ou importe-en une nouvelle"
      },
      "upload_failed": {
        "action_continue": "Continuer",
        "format_not_supported": "Certains fichiers ne sont pas compatibles. Veuillez les convertir en JPG ou PNG.",
        "text": "Nous avons eu des problèmes pour télécharger votre photo. Veuillez réessayer ou choisir une autre photo.",
        "title": "Échec du téléchargement"
      },
      "upload_photo": "Télécharger une photo",
      "upload_photos": "Télécharger des photos",
      "what_to_add": "Que voulez-vous ajouter ?",
      "incomplete_collage_warning": {
        "label": "Il manque des photos au collage."
      },
      "ai_tile_generating_warning": {
        "label": "Ton nouveau style est en cours de création.",
        "cta": "Voir",
        "popup_subtitle": "Tu pourras payer dès qu'il sera prêt."
      },
      "list_discount": {
        "banner": "Presidents' Day : {{v1}}% de Réduction sur les Livres Photo"
      },
      "remove_item_popup": {
        "title": "Es-tu sûr de vouloir le supprimer ?",
        "tiles": "Cela supprimera les cadres que tu as créés",
        "photo_book": "Cela supprimera le livre photo que tu as créé",
        "delete": "Supprimer"
      }
    },
    "cart_upsells": {
      "bath_time": {
        "card_title_dog": "Transformez votre chien en art de bain amusant !",
        "card_title_cat": "Transformez votre chat en art de bain amusant !",
        "card_cta": "Voir maintenant",
        "flow_title": "L'heure du bain"
      },
      "card_dismiss": "Ignorer",
      "wall_subtitle_one": "{{count}} cadre, {{size}}",
      "wall_subtitle_other": "{{count}} cadres, {{size}}",
      "add_tiles_one": "Ajouter {{count}} cadre",
      "add_tiles_other": "Ajouter {{count}} cadres",
      "select_tiles_to_add": "Sélectionnez des cadres",
      "select_tiles_to_continue": "Choisissez des cadres pour continuer",
      "wall_tile": "Cadre {{position}}"
    },
    "order_management": {
      "actions": {
        "change_address": "Changer l'adresse",
        "edit_order": "Modifier la commande",
        "duplicate_order": "Dupliquer la commande",
        "tracking_details": {
          "base": "Suivi de livraison",
          "not_shipped_suffix": "après envoi"
        },
        "edit_order_dialog": {
          "title": "Annuler et modifier ?",
          "subtitle": "Annuler et modifier arrêtera votre commande afin que vous puissiez la mettre à jour.",
          "refund_info": "Vous recevrez un crédit de {{v1}} à utiliser lors du paiement. Pour obtenir un remboursement à la place, contactez le support après l'annulation.",
          "button": "Annuler et modifier la commande",
          "go_back": "Conserver ma commande"
        },
        "view_order_summary": "Voir le résumé de commande"
      },
      "already_shipped_dialog": {
        "cancel_text": "Cette commande est déjà en production et ne peut plus être annulée.",
        "cancel_title": "Trop tard pour annuler",
        "update_text": "Cette commande est déjà en production et ne peut plus être modifiée.",
        "update_title": "Trop tard pour modifier",
        "ok": "Ok, j'ai compris"
      },
      "got_it": "Ok, j'ai compris",
      "modifying_existing_order_dialog": {
        "ok": "Ok, j'ai compris",
        "text": "Les changements effectués peuvent faire changer la date de livraison",
        "title": "Modifier une commande existante"
      },
      "order_card": {
        "created_at": "Créée le",
        "delivered_at": "Livrée le",
        "expected_arrival": "Arrivée prévue le",
        "number_of_photo_books": "Nombre de Livres Photo",
        "number_of_tiles": "Nombre de cadres",
        "order_number_prefix": "Commande"
      },
      "order_processing": {
        "cant_view_file": "Téléchargement impossible. Essayez un autre navigateur"
      },
      "order_processing_dialog": {
        "text": "Nous traitons votre commande. Merci de réessayer dans quelques minutes.",
        "title": "Traitement de la commande"
      },
      "statuses2": {
        "approved": "En production",
        "cancelled": "Annulée",
        "complete": "Livrée",
        "processing": "En traitement",
        "shipped": "En livraison"
      },
      "title": "Votre commande"
    },
    "out_of_stock": {
      "applied_to_other_materials": "Appliqué aux autres styles",
      "applied_to_x": "La modification a été appliquée au style {{v1}}",
      "applied_where_available": "Appliqué là où disponible",
      "available_in_other_materials": "Disponible dans d'autres types de matériel",
      "available_in_other_sizes": "Disponible dans d'autres tailles",
      "only_available_for_x": "Disponible uniquement pour {{v1}}",
      "some_tiles_arent_available_for_this_option": "Certains cadres ne sont pas disponibles avec cette option",
      "undo": "Annuler",
      "we_changed_some_frame_that_werent_available": "On a modifié certains cadres qui n'étaient pas disponibles",
      "x_isnt_available_in_x": "La couleur {{v1}} n'est pas disponible avec le style {{v2}}",
      "x_isnt_available_size_changed_to_x_subtitle": [
        "La taille a été remplacée par {{v1}}"
      ],
      "x_isnt_available_size_changed_to_x_title": [
        "{{v1}} n'est pas disponible"
      ],
      "x_only_available_in_x": "La couleur {{v1}} est seulement disponible avec le style {{v2}}",
      "x_x_isnt_available": "{{v1}} {{v2}} n'est pas disponible",
      "x_x_isnt_available_color_changed_to_x_subtitle": [
        "La couleur a été remplacée par du {{v1}}"
      ],
      "x_x_isnt_available_color_changed_to_x_title": [
        "{{v1}} {{v2}} n'est pas disponible"
      ],
      "x_available_in_selected_materials": "{{v1}} disponible dans les matériaux sélectionnés"
    },
    "photo": {
      "edit_tile": "Modifier le cadre",
      "photo_tiles": "Cadres photos"
    },
    "photo_book": {
      "product_names": {
        "newborn": "Livre Photo Nouveau-né",
        "family": "Livre Photo de Famille",
        "annual": "Livre Photo Annuel",
        "travel": "Livre Photo de Voyage",
        "wedding": "Livre Photo de Mariage"
      },
      "add_photos_dialog": {
        "title": "Où devons-nous placer vos nouvelles photos ?",
        "add_chronologically": "Ajouter chronologiquement",
        "add_at_end": "Ajouter à la fin"
      },
      "added_in_chronological_order": "Ajoutés par ordre chronologique",
      "arrange": {
        "name": "Organiser"
      },
      "arrival_notice": {
        "login_title_one": "Bon retour, {{count}} livre photo restauré dans votre panier",
        "login_title_other": "Bon retour, {{count}} livres photo restaurés dans votre panier",
        "title_one": "{{count}} livre photo restauré dans votre panier",
        "title_other": "{{count}} livres photo restaurés dans votre panier"
      },
      "cover": "couverture",
      "cover_edit": {
        "cover_photo_label": "Photo de couverture",
        "title": "Modifier la couverture",
        "title_font_label": "Police d'écriture du titre",
        "title_label": "Titre",
        "designed_covers": "Couvertures d'artiste",
        "upload": "Importer",
        "designs": "Designs",
        "select_cover": "Choisir la couverture",
        "crop_and_title_hint": "Pincer pour recadrer, toucher le titre pour modifier",
        "ai_cover_create": "Créer",
        "ai_cover_title": "Titre de ton livre",
        "ai_cover_headline_label": "Titre de ton livre",
        "ai_cover_headline_placeholder": "Titre de ton livre",
        "ai_cover_generate": "Créer la couverture",
        "ai_cover_retry": "Réessayer",
        "ai_cover_creating": "Création de la couverture",
        "ai_cover_ready_title": "Ta couverture est prête",
        "ai_cover_ready_action": "Modifier"
      },
      "cover_deep_link": {
        "rejected_title": "Un problème est survenu. Choisis à nouveau une couverture"
      },
      "deep_link_photos": {
        "rejected_title": "Un problème est survenu. Ajoute tes photos pour commencer ton livre"
      },
      "add_text": "Légende",
      "creating_book": "Création de l'album en cours…",
      "default_cover_text": "Moments de bonheur",
      "empty_book": "Le livre photo est vide.",
      "title": "Titre",
      "photo": "Photo",
      "ios_uploader": {
        "old_ux_message": "Une fois que vous avez appuyé sur « Ajouter », attendez 30 secondes pour le chargement des photos.",
        "old_ux_upload": "Télécharger des photos"
      },
      "low_res_photos": {
        "cart_cta": "Revoir",
        "cart_label": "Photos à faible résolution."
      },
      "not_enough_photos": {
        "cart_cta": "Ajouter",
        "cart_label": "Ajoutez {{numPhotos}} photos pour terminer.",
        "cart_title": "Ajoutez plus de photos à votre livre photo",
        "cta": "Ajouter d'autres photos",
        "subtitle": "Vous avez téléchargé moins de {{totalAmount}} photos. Veuillez ajouter {{missingAmount}} photos de plus pour compléter votre commande.",
        "title": "Il n'y a pas assez de photos"
      },
      "too_many_pages": {
        "title": "Presque fini ! Votre livre est un peu trop plein",
        "subtitle": "Un livre photo peut contenir jusqu'à {{maxPhotos}} photos. Retirez-en {{extraPhotos}} pour terminer votre livre.",
        "cta": "Modifier mon livre"
      },
      "page_1": "Page 1",
      "page_controls": {
        "adjust_crop": "Pincer pour recadrer",
        "delete_photo": "Supprimer",
        "replace_photo": "Remplacer",
        "caption_too_long": "La légende est trop longue"
      },
      "page_order": {
        "done": "Terminé",
        "snackbar": {
          "cover_back_cant_edit": "Le dos de la couverture ne peut pas être modifié",
          "pages_sorted": "Pages triées",
          "pages_sorted_by_date": "Pages triées par date",
          "undo": "Annuler"
        },
        "sort_by_date": "Trier par date",
        "sort_confirmation": {
          "approve": "Trier",
          "dismiss": "Annuler",
          "main_text": "Trier les photos de la plus récente à la plus ancienne",
          "title": "Trier les pages du livre par date"
        },
        "subtitle": "Faites glisser une photo pour la réorganiser",
        "title": "Aperçu des pages",
        "warning": {
          "missing_date": "Les photos marquées n'ont pas été triées automatiquement en raison de l'absence de date. Veuillez les classer manuellement"
        }
      },
      "page_range": "Page {{start}}-{{end}}",
      "page_single": "Page {{page}}",
      "pages_disabled_message": "Vous avez besoin de plus de photos pour réorganiser les pages",
      "photo_deleted": "Photo supprimée",
      "photos_not_uploaded": {
        "title": "{{count}} photos non téléversées",
        "subtitle": "Veuillez les rajouter avant de payer"
      },
      "photo_limit": {
        "title": "Nombre maximum de photos atteint",
        "message": "Nombre maximum de photos atteint. Supprimez-en quelques-unes pour en ajouter d'autres",
        "subtitle_single": "Veuillez supprimer 1 photo",
        "subtitle_plural": "Veuillez supprimer {{v1}} photos",
        "all_set": "Terminé ! Cliquez sur '{{done}}' pour continuer"
      },
      "size": "Taille",
      "size_selection": {
        "title": "Choisir une taille de livre",
        "select_size": "Choisir une taille",
        "page_count": "Nombre de pages",
        "tier_page_range": "{{start}} - {{end}} pages",
        "current_tier": "Palier actuel"
      },
      "swipe_pages": "Échanger la page",
      "turn_pages": "Tourner les pages",
      "updating_book": "Mise à jour de l'album en cours…",
      "replacing_photo": "Remplacement de la photo en cours…",
      "uploading_photos": "Envoi des photos"
    },
    "pitch": {
      "copyright": "© Copyright 2015-{{v1}} Mixtiles, LTD",
      "footer": {
        "about": "À propos",
        "accessibility": "Déclaration concernant l'accessibilité",
        "blog": "Notre Blog",
        "canvas_prints": "Impressions sur Toile",
        "careers": "Carrières",
        "cookie_policy": "Politique en matière de cookies",
        "facebook": "Facebook",
        "follow_us": "Suivez-nous",
        "gallery_walls": "Galerie murale",
        "impressum": "Impressum",
        "instagram": "Instagram",
        "join_us": "Rejoignez Mixtiles Engineering",
        "privacy": "Politique de Confidentialité",
        "products": "Produits",
        "resources": "Ressources",
        "terms_of_use": "Conditions générales de vente",
        "twitter": "Twitter",
        "tokushoho": "特定商取引法に基づく表記"
      },
      "footer_links": {
        "accessibility_statement": "Déclaration concernant l'accessibilité",
        "impressum": "IMPRESSUM",
        "privacy_policy": "Politique de Confidentialité",
        "terms_of_use": "Conditions générales de vente",
        "cookie_policy": "POLITIQUE DE COOKIES"
      },
      "global_shipping": "Livraison internationale et rapide",
      "headline": "Transformez vos photos en de magnifiques et abordables objets d'art",
      "icons": {
        "satisfaction": {
          "text": "Pas satisfait ? Nous vous remboursons intégralement",
          "title": "Satisfaction garantie"
        }
      },
      "main_button_cta": "C'est parti !"
    },
    "product": {
      "carousel": {
        "adjust_to_perfection": "Ajustez vos cadres à la perfection",
        "no_damage": "Sans aucune trace",
        "peel_stick": "Décollez la feuille de protection et collez votre cadre au mur."
      }
    },
    "product_page": {
      "art_product": {
        "description": "Une œuvre d'Art qui adhère à n'importe quel mur, ne laisse pas de traces et peut être repositionnée à tout moment.",
        "description_mobile": {
          "no_nails": "Pas besoin de clous, adhère à tout type de mur",
          "satisfaction": "Satisfaction garantie"
        }
      },
      "choose_your_own_style": "Choisissez votre propre style",
      "community": {
        "description": "Voici ce que nos clients disent de nous",
        "load_more": "Télécharger plus d'avis",
        "title": "Notre communauté"
      },
      "controls": {
        "art": {
          "browse": "Parcourir la collection d'art",
          "start": "Ajouter une œuvre d'art"
        },
        "frame_size": "Taille du cadre",
        "frame_style": "Style de cadre",
        "photobook": {
          "start": "Ajouter au panier"
        },
        "tile": {
          "start": "Commencer à créer"
        }
      },
      "magnetic_hanging": {
        "description": "Alignez, ajustez et repositionnez parfaitement vos cadres sans aucun dégât et en toute simplicité. Redécorez librement votre espace à chaque fois que vous le souhaitez.",
        "title": "Découvrez le système d'accrochage magnétique"
      },
      "photobook_product": {
        "beauty": {
          "subtitle": "Chaque livre photo est doté d'une couverture rigide et mate et est imprimé sur des pages de qualité supérieure avec une finition soyeuse.",
          "title": "De la beauté à chaque page"
        },
        "bullet_points": {
          "free_shipping": "Livraison Gratuite",
          "no_hidden_fees": "Sans aucun frais additionnel",
          "same_price": "Un prix unique, quel que soit le nombre de pages",
          "simple_pricing": "Prix simples, sans surprises"
        },
        "description": "Concevez votre livre photo en quelques touches et voyez-le prendre vie en 3D.",
        "description_mobile": {
          "fixed_price": "Un prix unique, quel que soit le nombre de pages",
          "quality_book": "Des impressions de qualité, un livre photo à couverture rigide",
          "free_shipping": "Livraison Gratuite"
        },
        "title": {
          "default": "Des livres photo en toute simplicité"
        }
      },
      "price_each": "/ par cadre",
      "reviews_count": "Avec plus de 100 000 évaluations sur l'App Store",
      "tile_product": {
        "description": "Des images imprimées encadrées et repositionnables, qui adhèrent à tout type de mur sans laisser de traces.",
        "description_mobile": {
          "no_nails": "Pas besoin de clous, adhère à tout type de mur",
          "satisfaction": "Satisfaction garantie"
        },
        "tile": "Cadre",
        "title": {
          "canvas": "Des impressions sur toile repositionnables",
          "regular": "Des cadres photos repositionnables"
        }
      },
      "explore": {
        "art": "Explorer l'Art",
        "canvas_prints": "Explorer les Impressions sur Toile",
        "photo_books": "Explorer les Livres Photo",
        "photo_tiles": "Explorer les Cadres Photos"
      },
      "reviews_count_mobile": "100k+ évaluations"
    },
    "product_selection": {
      "photo_books_name": "Livres Photo",
      "tiles_name": "Cadres",
      "title_choose_what_to_create": "Choisis ce que tu veux créer"
    },
    "rating": {
      "back_to_mixtiles": "Retourner sur Mixtiles",
      "comment": {
        "1-2-stars": {
          "sentence": "On est désolés ! Pourriez-vous nous dire ce qui ne s'est pas bien passé ?"
        },
        "3-4-stars": {
          "question": "Comment peut-on s'améliorer ?",
          "sentence": "On veut toujours faire mieux !"
        },
        "5-stars": {
          "question": "Qu'avez-vous particulièrement aimé ?",
          "sentence": "On est ravis !"
        }
      },
      "contact_us": "nous contacter.",
      "feel_free": "Si on peut vous apporter de l'aide, n'hésitez pas à",
      "first_question": "Comment a été votre expérience d'achat chez Mixtiles ?",
      "next": "Suivant",
      "star_caption": {
        "1": "Épouvantable",
        "2": "Mauvaise",
        "3": "Ok",
        "4": "Bonne",
        "5": "Excellente"
      },
      "submit": "Envoyer",
      "tell_us_here": "Dites-nous-en un peu plus... (optionnel)",
      "thanks": "Merci de nous avoir donné votre avis !"
    },
    "refresher_kit_request": {
      "back": "Retour",
      "confirmation": {
        "received_title": "Nous avons reçu votre demande !"
      },
      "contact_support": "Contacter le support",
      "continue": "Continuer",
      "continue_with_count": "Continuer ({{count}})",
      "errors": {
        "invalid_email": "Veuillez saisir une adresse e-mail valide",
        "invalid_state": "Veuillez saisir un État valide",
        "invalid_submission": "Nous n’avons pas pu accepter cette demande. Vérifiez votre sélection et vos informations, puis réessayez.",
        "load_failed": "Oups, un problème est survenu.",
        "required": "Obligatoire",
        "submit_failed": "Nous n’avons pas pu envoyer votre demande. Veuillez réessayer."
      },
      "expired": {
        "body": "Contactez notre équipe support et nous vous en enverrons un nouveau.",
        "title": "Ce lien a expiré"
      },
      "frame_name": "Cadre {{v1}}",
      "inactive": {
        "body": "Contactez notre équipe support et nous vous aiderons à tout régler.",
        "title": "Ce lien n’est plus actif"
      },
      "invalid_link": {
        "body": "Contactez notre équipe support et nous vous aiderons à tout régler.",
        "title": "Ce lien n’est pas valide"
      },
      "no_orders": {
        "body": "Contactez notre équipe support et nous vous aiderons à tout régler.",
        "title": "Nous n’avons trouvé aucune commande livrée sur ce compte"
      },
      "select": {
        "title": "Sélectionnez les cadres à rafraîchir et recevez des adhésifs de remplacement"
      },
      "selected_badge": "{{v1}} sélectionnés",
      "selected_of_tiles": "{{v1}}/{{v2}} cadres",
      "sending": "Envoi de votre demande...",
      "shipping": {
        "country": "Pays",
        "email": "E-mail",
        "submit": "Recevoir le kit",
        "subtitle": "Vos adhésifs de remplacement vous sont envoyés gratuitement.",
        "title": "Où devons-nous l’envoyer ?"
      },
      "summary": {
        "adhesives_many": "{{v1}} adhésifs de remplacement",
        "adhesives_one": "1 adhésif de remplacement",
        "title": "Récapitulatif ({{v1}})"
      },
      "switch_account": "Changer de compte",
      "tile_count_many": "{{v1}} cadres",
      "tile_count_one": "1 cadre",
      "try_again": "Réessayer",
      "wrong_account": {
        "body": "Connectez-vous avec le compte auquel ce lien a été envoyé, ou contactez notre équipe support.",
        "title": "Ce lien appartient à un autre compte"
      }
    },
    "referral": {
      "already_referred": "Vous avez déjà envoyé une carte-cadeau à ce destinataire. Veuillez saisir une autre adresse électronique.",
      "general_error": "Une erreur s'est produite lors de l'envoi de la carte cadeau. Veuillez réessayer plus tard.",
      "login": "Connectez-vous pour continuer",
      "menu_title": "Programme de parrainage",
      "referral_sent": "<div>La carte-cadeau a été envoyée à  <b>{{v1}}</b>!<br> Une fois leur achat effectué, vous recevrez <b>{{v2}}</b> en bon de réduction et serez informé.e par e-mail.</div>",
      "self_referral": "Vous ne pouvez pas vous envoyer une carte-cadeau de parrainage à vous-même. Veuillez saisir une autre adresse électronique.",
      "send": "Envoyer maintenant",
      "subtitle": "Pour chaque ami qui effectue un achat, vous recevrez {{v1}}} en bon de réduction - gratuitement !",
      "title": "Donnez {{v1}}, Recevez {{v1}}"
    },
    "size_selection": {
      "price_per_tile": "{{v1}} par cadre"
    },
    "wall_designer": {
      "highlighted_tile": {
        "edit_tile": "Modifier cadre",
        "swap_position": "Changer de place",
        "swap_position_title": "Choisis une photo à échanger"
      },
      "photos_selector": {
        "selected": "sélectionnées",
        "title": "Sélectionnez {{v1}} photos"
      },
      "preferences_saved": {
        "cta": "Retour à la page d'accueil",
        "subtitle": "On espère vous revoir bientôt pour plus de produits et offres exceptionnels",
        "title": "Vos préférences ont été mises à jour"
      },
      "zoom_button": {
        "full_view": "Vue complète",
        "zoom": "Zoomer"
      }
    },
    "wall_feed": {
      "categories": {
        "large": "Grand",
        "medium": "Moyen",
        "small": "Petit"
      }
    },
    "cancel_order_v2": {
      "cta": "Annuler la commande",
      "dialog": {
        "title": "Annuler la Commande",
        "refund_content": "Vous recevrez un remboursement intégral de {{sum}}.",
        "refund_refund_info": "Le remboursement sera appliqué à votre moyen de paiement d'origine.",
        "dismiss": "Conserver ma commande"
      }
    },
    "seo": {
      "art": {
        "base": {
          "title": "Art par Mixtiles",
          "description": "Transformez vos photos en art mural abordable et magnifique"
        }
      },
      "canvas": {
        "base": {
          "title": "Impressions sur toile par Mixtiles",
          "h1": "Impressions photo sur toile personnalisées",
          "description": "Transformez vos photos personnelles en superbes impressions sur toile que vous pouvez accrocher partout — sans utiliser de clous !"
        },
        "sized": {
          "title": "Impressions sur toile {{size}} par Mixtiles",
          "h1": "Impressions sur toile {{size}}",
          "description": "Transformez vos photos en magnifiques impressions sur toile {{size}} — sans clous, sans dommages, juste un art mural facile."
        }
      },
      "phototiles": {
        "base": {
          "title": "Cadres photo repositionnables par Mixtiles",
          "h1": "Cadres photo repositionnables",
          "description": "Transformez vos photos en superbes cadres photo sans clous ni dommages au mur grâce à Mixtiles."
        },
        "sized": {
          "title": "Cadres photo {{size}} par Mixtiles",
          "h1": "Cadres photo {{size}}",
          "description": "Transformez vos photos en élégants cadres photo {{size}} qui adhèrent aux murs sans clous ni outils."
        },
        "withMaterial": {
          "title": "Cadres photo {{size}} {{frameDisplay}} par Mixtiles",
          "h1": "Cadres photo {{size}} {{frameDisplay}}",
          "description": "Transformez vos photos en élégants cadres photo {{size}} {{frameDisplayLower}} qui adhèrent aux murs sans clous ni outils."
        }
      },
      "photobooks": {
        "base": {
          "title": "Livres photo par Mixtiles",
          "h1": "Livres photo",
          "description": "Créez de magnifiques livres photo avec Mixtiles. Transformez vos souvenirs en précieux trésors qui durent toute une vie."
        },
        "sized": {
          "title": "Livre Photo {{size}} par Mixtiles",
          "h1": "Livre Photo {{size}}",
          "description": "{{description}}"
        },
        "wedding": {
          "title": "Livres photo de mariage par Mixtiles",
          "h1": "Livres photo de mariage",
          "description": "Célébrez votre histoire d'amour avec les livres photo de mariage par Mixtiles. Créez de superbes albums, revivez vos moments précieux et profitez d'une qualité qui dure toute une vie.",
          "sized": {
            "title": "Livre photo de mariage {{size}} par Mixtiles",
            "h1": "Livre photo de mariage {{size}}"
          }
        },
        "memory": {
          "title": "Livre photo souvenirs par Mixtiles",
          "h1": "Livre photo souvenirs",
          "description": "Transformez vos plus beaux souvenirs en un magnifique livre photo souvenirs par Mixtiles. Revivez chaque moment avec des détails époustouflants !",
          "sized": {
            "title": "Livre photo souvenirs {{size}} par Mixtiles",
            "h1": "Livre photo souvenirs {{size}}"
          }
        },
        "small": {
          "title": "Petit livre photo par Mixtiles",
          "h1": "Petit livre photo",
          "description": "Mettez en valeur les plus petits moments de la vie avec un petit livre photo par Mixtiles. De grands souvenirs, compacts et magnifiques.",
          "sized": {
            "title": "Petit livre photo {{size}} par Mixtiles",
            "h1": "Petit livre photo {{size}}"
          }
        },
        "boudoir": {
          "title": "Livre photo boudoir par Mixtiles",
          "h1": "Livre photo boudoir",
          "description": "Célébrez la confiance en vous avec un livre photo boudoir par Mixtiles. Un souvenir audacieux et magnifique rien que pour vous.",
          "sized": {
            "title": "Livre photo boudoir {{size}} par Mixtiles",
            "h1": "Livre photo boudoir {{size}}"
          }
        },
        "travel": {
          "title": "Livre photo de voyage par Mixtiles",
          "h1": "Livre photo de voyage",
          "description": "Mettez vos aventures en valeur avec un livre photo de voyage par Mixtiles. Capturez vos périples, revivez chaque étape et gardez vos souvenirs de voyage à portée de main.",
          "sized": {
            "title": "Livre photo de voyage {{size}} par Mixtiles",
            "h1": "Livre photo de voyage {{size}}"
          }
        },
        "coffee-table": {
          "title": "Livre photo de table basse par Mixtiles",
          "h1": "Livre photo de table basse",
          "description": "Ajoutez de la personnalité à votre décoration avec un livre photo de table basse par Mixtiles. Style et souvenirs réunis dans une pièce parfaite.",
          "sized": {
            "title": "Livre photo de table basse {{size}} par Mixtiles",
            "h1": "Livre photo de table basse {{size}}"
          }
        },
        "engagement": {
          "title": "Livre photo de fiançailles par Mixtiles",
          "h1": "Livre photo de fiançailles",
          "description": "Capturez votre histoire d'amour avec un livre photo de fiançailles par Mixtiles. Un souvenir que vous chérirez pour toujours.",
          "sized": {
            "title": "Livre photo de fiançailles {{size}} par Mixtiles",
            "h1": "Livre photo de fiançailles {{size}}"
          }
        },
        "family": {
          "title": "Livre photo de famille par Mixtiles",
          "h1": "Livre photo de famille",
          "description": "Célébrez les moments forts de la famille avec un livre photo de famille par Mixtiles. Des souvenirs à partager encore et encore.",
          "sized": {
            "title": "Livre photo de famille {{size}} par Mixtiles",
            "h1": "Livre photo de famille {{size}}"
          }
        },
        "anniversary": {
          "title": "Livre photo d'anniversaire de mariage par Mixtiles",
          "h1": "Livre photo d'anniversaire de mariage",
          "description": "Honorez votre histoire d'amour avec un livre photo d'anniversaire de mariage par Mixtiles. Célébrez des années de souvenirs magnifiquement.",
          "sized": {
            "title": "Livre photo d'anniversaire de mariage {{size}} par Mixtiles",
            "h1": "Livre photo d'anniversaire de mariage {{size}}"
          }
        },
        "pet-dog": {
          "title": "Album photo de chien par Mixtiles",
          "h1": "Album photo de chien",
          "description": "Célébrez votre meilleur ami à quatre pattes avec un album photo de chien par Mixtiles. Chaque battement de queue, capturé pour toujours.",
          "sized": {
            "title": "Album photo de chien {{size}} par Mixtiles",
            "h1": "Album photo de chien {{size}}"
          }
        },
        "mothers-day": {
          "title": "Livre photo de la fête des Mères par Mixtiles",
          "h1": "Livre photo de la fête des Mères",
          "description": "Offrez à maman le souvenir ultime avec un livre photo de la fête des Mères par Mixtiles. Rempli d'amour, de rires et de souvenirs.",
          "sized": {
            "title": "Livre photo de la fête des mères {{size}} par Mixtiles",
            "h1": "Livre photo de la fête des mères {{size}}"
          }
        },
        "christmas": {
          "title": "Livre photo de Noël par Mixtiles",
          "h1": "Livre photo de Noël",
          "description": "Partagez la magie des fêtes avec un livre photo de Noël par Mixtiles. Un cadeau qu'ils chériront année après année.",
          "sized": {
            "title": "Livre photo de noël {{size}} par Mixtiles",
            "h1": "Livre photo de noël {{size}}"
          }
        },
        "fathers-day": {
          "title": "Livre photo de la fête des Pères par Mixtiles",
          "h1": "Livre photo de la fête des Pères",
          "description": "Montrez à papa qu'il est votre héros avec un livre photo de la fête des Pères par Mixtiles. Des histoires qu'il chérira pour toujours.",
          "sized": {
            "title": "Livre photo de la fête des pères {{size}} par Mixtiles",
            "h1": "Livre photo de la fête des pères {{size}}"
          }
        },
        "retirement": {
          "title": "Livre photo de retraite par Mixtiles",
          "h1": "Livre photo de retraite",
          "description": "Célébrez de nouveaux départs avec un livre photo de retraite par Mixtiles. Des souvenirs de travail acharné et de repos bien mérité.",
          "sized": {
            "title": "Livre photo de retraite {{size}} par Mixtiles",
            "h1": "Livre photo de retraite {{size}}"
          }
        },
        "birthday": {
          "title": "Livre photo d'anniversaire par Mixtiles",
          "h1": "Livre photo d'anniversaire",
          "description": "Transformez vos souvenirs d'anniversaire en trésors durables avec un livre photo d'anniversaire par Mixtiles. Chaque année mérite une page !",
          "sized": {
            "title": "Livre photo d'anniversaire {{size}} par Mixtiles",
            "h1": "Livre photo d'anniversaire {{size}}"
          }
        },
        "graduation": {
          "title": "Livre photo de remise de diplôme par Mixtiles",
          "h1": "Livre photo de remise de diplôme",
          "description": "Marquez cette étape importante avec un livre photo de remise de diplôme par Mixtiles. Capturez tous les moments qui ont rendu le voyage inoubliable.",
          "sized": {
            "title": "Livre photo de remise de diplôme {{size}} par Mixtiles",
            "h1": "Livre photo de remise de diplôme {{size}}"
          }
        },
        "yearly": {
          "title": "Livre photo annuel par Mixtiles",
          "h1": "Livre photo annuel",
          "description": "Racontez l'histoire de votre année avec un livre photo annuel par Mixtiles. Chaque moment fort, chaque souvenir, réuni en un seul endroit.",
          "sized": {
            "title": "Livre photo annuel {{size}} par Mixtiles",
            "h1": "Livre photo annuel {{size}}"
          }
        },
        "valentines": {
          "title": "Livre photo de la Saint-Valentin par Mixtiles",
          "h1": "Livre photo de la Saint-Valentin",
          "description": "Célébrez l'amour avec un livre photo de la Saint-Valentin par Mixtiles. Des souvenirs plus doux que le chocolat.",
          "sized": {
            "title": "Livre photo de la saint-valentin {{size}} par Mixtiles",
            "h1": "Livre photo de la saint-valentin {{size}}"
          }
        },
        "recipe": {
          "title": "Livre photo de recettes par Mixtiles",
          "h1": "Livre photo de recettes",
          "description": "Savourez chaque moment délicieux avec un livre photo de recettes par Mixtiles. Vos plats préférés, pour toujours à portée de main.",
          "sized": {
            "title": "Livre photo de recettes {{size}} par Mixtiles",
            "h1": "Livre photo de recettes {{size}}"
          }
        },
        "deals": {
          "title": "Offres Livres Photo par Mixtiles",
          "h1": "Offres Livres Photo",
          "description": "Découvrez d'incroyables offres de livres photo avec Mixtiles. Créez de magnifiques livres photo à des prix imbattables et transformez vos souvenirs en trésors durables.",
          "sized": {
            "title": "Offres Livres Photo {{size}} par Mixtiles",
            "h1": "Offres Livres Photo {{size}}"
          }
        },
        "designed-covers": {
          "title": "Livre photo à couverture design par Mixtiles",
          "h1": "Livre photo à couverture design",
          "description": "Donnez une finition soignée à votre livre photo avec un Livre photo à couverture design par Mixtiles. Choisissez parmi de magnifiques couvertures et transformez vos souvenirs en un trésor à exposer.",
          "sized": {
            "title": "Livre photo à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo à couverture design {{size}}"
          }
        },
        "baby": {
          "title": "Livre photo de bébé par Mixtiles",
          "h1": "Livre photo de bébé",
          "description": "Transformez la première année en un livre photo de bébé par Mixtiles. Choisissez vos photos préférées, ajoutez un titre et recevez un livre fait pour durer.",
          "sized": {
            "title": "Livre photo de bébé {{size}} par Mixtiles",
            "h1": "Livre photo de bébé {{size}}"
          }
        },
        "wedding-designed-covers": {
          "title": "Livre photo de mariage à couverture design par Mixtiles",
          "h1": "Livre photo de mariage à couverture design",
          "description": "Commencez votre livre de mariage avec une couverture créée pour lui. Choisissez le style, ajoutez vos photos et Mixtiles imprime un livre à exposer.",
          "sized": {
            "title": "Livre photo de mariage à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo de mariage à couverture design {{size}}"
          }
        },
        "baby-designed-covers": {
          "title": "Livre photo de bébé à couverture design par Mixtiles",
          "h1": "Livre photo de bébé à couverture design",
          "description": "Choisissez une couverture pensée pour les photos de bébé et laissez Mixtiles remplir les pages de la première année. Aucune mise en page à faire.",
          "sized": {
            "title": "Livre photo de bébé à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo de bébé à couverture design {{size}}"
          }
        },
        "birthday-designed-covers": {
          "title": "Livre photo d'anniversaire à couverture design par Mixtiles",
          "h1": "Livre photo d'anniversaire à couverture design",
          "description": "Enveloppez une année de photos d'anniversaire dans une couverture créée pour l'occasion. Choisissez le style, ajoutez vos photos, Mixtiles en fait un cadeau.",
          "sized": {
            "title": "Livre photo d'anniversaire à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo d'anniversaire à couverture design {{size}}"
          }
        },
        "coffee-table-designed-covers": {
          "title": "Livre photo de table basse à couverture design par Mixtiles",
          "h1": "Livre photo de table basse à couverture design",
          "description": "Une couverture design pour un livre qui reste à la vue de tous. Choisissez le style, ajoutez vos meilleures photos et Mixtiles leur donne une belle finition.",
          "sized": {
            "title": "Livre photo de table basse à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo de table basse à couverture design {{size}}"
          }
        },
        "proposal-designed-covers": {
          "title": "Livre photo de demande en mariage à couverture design par Mixtiles",
          "h1": "Livre photo de demande en mariage à couverture design",
          "description": "Gardez la demande en mariage dans un livre à couverture design. Choisissez le style, ajoutez les photos du jour et revivez le oui à chaque ouverture.",
          "sized": {
            "title": "Livre photo de demande en mariage à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo de demande en mariage à couverture design {{size}}"
          }
        },
        "christmas-designed-covers": {
          "title": "Livre photo de Noël à couverture design par Mixtiles",
          "h1": "Livre photo de Noël à couverture design",
          "description": "Offrez à vos photos de Noël une couverture festive créée pour la saison. Choisissez le style, ajoutez vos photos et rouvrez le livre chaque année.",
          "sized": {
            "title": "Livre photo de Noël à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo de Noël à couverture design {{size}}"
          }
        },
        "family-designed-covers": {
          "title": "Livre photo de famille à couverture design par Mixtiles",
          "h1": "Livre photo de famille à couverture design",
          "description": "Choisissez une couverture design pour votre livre de famille et laissez Mixtiles transformer le quotidien en un trésor à faire circuler.",
          "sized": {
            "title": "Livre photo de famille à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo de famille à couverture design {{size}}"
          }
        },
        "school-years-designed-covers": {
          "title": "Livre photo des années d'école à couverture design par Mixtiles",
          "h1": "Livre photo des années d'école à couverture design",
          "description": "Réunissez les années d'école dans un livre à couverture design. Choisissez le style, ajoutez les photos et regardez les années remplir les pages.",
          "sized": {
            "title": "Livre photo des années d'école à couverture design {{size}} par Mixtiles",
            "h1": "Livre photo des années d'école à couverture design {{size}}"
          }
        }
      },
      "variant_links": {
        "phototiles_material": "Cadres photos {{frameDisplay}}"
      }
    },
    "tile_upsell": {
      "centerpiece": {
        "button": "Personnaliser Maintenant",
        "subtitle": "Seulement {{price}}",
        "title": "Ajoutez un panneau personnalisé à votre mur"
      },
      "collage": {
        "button": "Personnaliser Maintenant",
        "subtitle": "{{size}} pour {{price}}",
        "title": "Un collage de vos photos ferait un superbe cadeau"
      },
      "referral": {
        "button": "Partager le lien",
        "subtitle": "Ce lien leur offre ${{price}} de réduction",
        "title": "Vous avez des amis qui adoreraient Mixtiles ?"
      },
      "title": "Commande Terminée !"
    }
  }
}
